<template>
  <div class="box" ref="ui">
    <el-container  @click.native="handleClick">
      <el-header height="48px" v-show="$store.state.hidden.menu">
        <div class="my-div1">
          <!--        <el-menu-->
          <!--          :default-active="activeIndex"-->
          <!--          class="el-menu-demo"-->
          <!--          mode="horizontal"-->
          <!--          :unique-opened="true"-->
          <!--          menu-trigger="click"-->
          <!--          ref="topMenu"-->
          <!--          :router="false"-->
          <!--          @select="handleSelect"-->
          <!--          @open="handleOpen"-->
          <!--          :background-color="backgroundcolor"-->
          <!--          :text-color="textcolor"-->
          <!--          :active-text-color="activetextcolor">-->
          <!--          &lt;!&ndash;          <el-menu-item><i class="">&ndash;&gt;-->
          <!--          &lt;!&ndash;            <img :src="bookImg"  style="height:100%">&ndash;&gt;-->
          <!--          &lt;!&ndash;          </i></el-menu-item>&ndash;&gt;-->
          <!--          <el-menu-item index="SystemManagement" v-show="menu.SystemManagement.show">{{menu.SystemManagement.name}}</el-menu-item>-->

          <!--          <el-submenu index="5" :disabled="showDiesel" v-show="menu.DieselMonitorSystem.show">-->
          <!--            <template slot="title">{{menu.DieselMonitorSystem.name}}</template>-->
          <!--            <el-menu-item index="/DieselMonitorSystem/OverviewGraph" v-show="menu.DieselMonitorSystem.data['5-1']">-->
          <!--              {{menu.DieselMonitorSystem.data._51name}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/DieselMonitorSystem/DieselMonitorRunStatus"-->
          <!--                          v-show="menu.DieselMonitorSystem.data['5-2']">{{menu.DieselMonitorSystem.data._52name}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/DieselMonitorSystem/HistoricalComparisonGraph"-->
          <!--                          v-show="menu.DieselMonitorSystem.data['5-3']">{{menu.DieselMonitorSystem.data._53name}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/DieselMonitorSystem/SingleValueStickGraph"-->
          <!--                          v-show="menu.DieselMonitorSystem.data['5-4']">{{menu.DieselMonitorSystem.data._54name}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/DieselMonitorSystem/DynamicPressureMonitorGraph"-->
          <!--                          v-show="menu.DieselMonitorSystem.data['5-5']">{{menu.DieselMonitorSystem.data._55name}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/DieselMonitorSystem/EventQueryGraph" v-show="menu.DieselMonitorSystem.data['5-7']">-->
          <!--              {{menu.DieselMonitorSystem.data._57name}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/DieselMonitorSystem/VibrationMonitorGraph"-->
          <!--                          v-show="menu.DieselMonitorSystem.data['5-8']">{{menu.DieselMonitorSystem.data._58name}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/DieselMonitorSystem/InstantaneousSpeed" v-show="menu.DieselMonitorSystem.data['5-9']">-->
          <!--              {{menu.DieselMonitorSystem.data._59name}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/DieselMonitorSystem/TorsionalVibration" v-show="menu.DieselMonitorSystem.data['5-11']">-->
          <!--              {{menu.DieselMonitorSystem.data._511name}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/DieselMonitorSystem/MultiparameterAnalysis"-->
          <!--                          v-show="menu.DieselMonitorSystem.data['5-12']">{{menu.DieselMonitorSystem.data._512name}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/DieselMonitorSystem/ComprehensiveAnalysisGraph"-->
          <!--                          v-show="menu.DieselMonitorSystem.data['5-14']">{{menu.DieselMonitorSystem.data._514name}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/DieselMonitorSystem/IndicatorGraph" v-show="menu.DieselMonitorSystem.data['5-16']">-->
          <!--              {{menu.DieselMonitorSystem.data._516name}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/DieselMonitorSystem/ImpactDiagnosis" v-show="menu.DieselMonitorSystem.data['5-17']">-->
          <!--              {{menu.DieselMonitorSystem.data._517name}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/DieselMonitorSystem/OtherParametersTrend"-->
          <!--                          v-show="menu.DieselMonitorSystem.data['5-18']">{{menu.DieselMonitorSystem.data._518name}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/DieselMonitorSystem/AlarmQuery" v-show="menu.DieselMonitorSystem.data['5-19']">{{menu.DieselMonitorSystem.data._519name}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/DieselMonitorSystem/OnAndOffStateAnalysis"-->
          <!--                          v-show="menu.DieselMonitorSystem.data['5-21']">{{menu.DieselMonitorSystem.data._521name}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/DieselMonitorSystem/StartAndStopTimeQuery"-->
          <!--                          v-show="menu.DieselMonitorSystem.data['5-22']">{{menu.DieselMonitorSystem.data._522name}}-->
          <!--            </el-menu-item>-->

          <!--          </el-submenu>-->
          <!--          &lt;!&ndash;          <el-submenu index="/4" v-show="menu.ReciprocatMachineryGraph.show">&ndash;&gt;-->
          <!--          <el-submenu index="4" :disabled="showReciprocat" v-show="menu.ReciprocatMachineryGraph.show">-->
          <!--            <template slot="title">{{translateText("textMap.", menu.ReciprocatMachineryGraph.name)}}</template>-->
          <!--            <el-menu-item index="/ReciprocatMachineryGraph/OverviewGraph1"-->
          <!--                          v-show="menu.ReciprocatMachineryGraph.data['4-1']"><img :src="imgUrl_WangFM" style="height: 15px;width: 20px;background: white"> {{translateText("textMap.", menu.ReciprocatMachineryGraph.data._41name)}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/ReciprocatMachineryGraph/ReciprocatAlarmQuery"-->
          <!--                          v-show="menu.ReciprocatMachineryGraph.data['4-2']"><img :src="imgUrl_Alarm_Q" style="height: 15px;width: 20px;background: white">  {{translateText('textMap.', menu.ReciprocatMachineryGraph.data._42name)}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/ReciprocatMachineryGraph/ReciprocatVibrationMonitor"-->
          <!--                          v-show="menu.ReciprocatMachineryGraph.data['4-3']"><img :src="imgUrl_XuanVib" style="height: 15px;width: 20px;background: white">  {{translateText('textMap.', menu.ReciprocatMachineryGraph.data._43name)}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/ReciprocatMachineryGraph/HistoricalComparisonGraph1"-->
          <!--                          v-show="menu.ReciprocatMachineryGraph.data['4-4']"><img :src="imgUrl_XuanHisCompare" style="height: 15px;width: 20px;background: white">  {{translateText("textMap.", menu.ReciprocatMachineryGraph.data._44name)}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/ReciprocatMachineryGraph/PistonRodSettlement"-->
          <!--                          v-show="menu.ReciprocatMachineryGraph.data['4-5']"><img :src="imgUrl_Wang_HBai" style="height: 15px;width: 20px;background: white">  {{translateText("textMap.",menu.ReciprocatMachineryGraph.data._45name)}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/ReciprocatMachineryGraph/IndicatorGraph1"-->
          <!--                          v-show="menu.ReciprocatMachineryGraph.data['4-6']"><img :src="imgUrl_Wang_SG" style="height: 15px;width: 20px;background: white">  {{translateText("textMap.",menu.ReciprocatMachineryGraph.data._46name)}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/ReciprocatMachineryGraph/StressMonitoring"-->
          <!--                          v-show="menu.ReciprocatMachineryGraph.data['4-7']"><img :src="imgUrl_Wang_YJ" style="height: 15px;width: 20px;background: white">  {{translateText("textMap.",menu.ReciprocatMachineryGraph.data._47name)}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/ReciprocatMachineryGraph/RunStatusGraph1"-->
          <!--                          v-show="menu.ReciprocatMachineryGraph.data['4-8']"><img :src="imgUrl_Xuan_RunS" style="height: 15px;width: 20px;background: white">  {{translateText('textMap.', menu.ReciprocatMachineryGraph.data._48name)}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/ReciprocatMachineryGraph/MultiparameterAnalysis1"-->
          <!--                          v-show="menu.ReciprocatMachineryGraph.data['4-9']"><img :src="imgUrl_Wang_DCS" style="height: 15px;width: 20px;background: white">  {{translateText('textMap.', menu.ReciprocatMachineryGraph.data._49name)}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/ReciprocatMachineryGraph/OtherParametersTrend1"-->
          <!--                          v-show="menu.ReciprocatMachineryGraph.data['4-10']"><img :src="imgUrl_Other_Parameters" style="height: 15px;width: 20px;background: white">  {{translateText("textMap.",menu.ReciprocatMachineryGraph.data._410name)}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/ReciprocatMachineryGraph/SingleValueStickGraph1"-->
          <!--                          v-show="menu.ReciprocatMachineryGraph.data['4-11']"><img :src="imgUrl_Single_Multi" style="height: 15px;width: 20px;background: white">  {{translateText("textMap.",menu.ReciprocatMachineryGraph.data._411name)}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/ReciprocatMachineryGraph/ReciprocatComprehensiveAnalysis"-->
          <!--                          v-show="menu.ReciprocatMachineryGraph.data['4-12']"><img :src="imgUrl_Xuan_ZongH" style="height: 15px;width: 20px;background: white">  {{translateText("textMap.",menu.ReciprocatMachineryGraph.data._412name)}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/ReciprocatMachineryGraph/PistonRodTrackGraph"-->
          <!--                          v-show="menu.ReciprocatMachineryGraph.data['4-13']"><img :src="imgUrl_Wang_HGuiJi" style="height: 15px;width: 20px;background: white">  {{menu.ReciprocatMachineryGraph.data._413name}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/ReciprocatMachineryGraph/ImpactDiagnosis1"-->
          <!--                          v-show="menu.ReciprocatMachineryGraph.data['4-14']"><img :src="imgUrl_Pump_P" style="height: 15px;width: 20px;background: white">  {{menu.ReciprocatMachineryGraph.data._414name}}-->
          <!--            </el-menu-item>-->
          <!--          </el-submenu>-->
          <!--          &lt;!&ndash;          <el-submenu index="6" v-show="menu.RotatingMachineryGraph.show">&ndash;&gt;-->
          <!--          <el-submenu index="6" :disabled="showRotating" v-show="menu.RotatingMachineryGraph.show">-->
          <!--            <template slot="title">{{ translateText("textMap.", menu.RotatingMachineryGraph.name) }}</template>-->
          <!--            <el-menu-item index="/RotatingMachineryGraph/RotatingOverviewGrap"-->
          <!--                          v-show="menu.RotatingMachineryGraph.data['6-15']"><img :src="imgUrl_Xuan_Map" style="height: 15px;width: 20px;background: white"> {{translateText("textMap.", menu.RotatingMachineryGraph.data._615name) }}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/RotatingMachineryGraph/AlarmQueryGraph2"-->
          <!--                          v-show="menu.RotatingMachineryGraph.data['6-10']"><img :src="imgUrl_Alarm_Q" style="height: 15px;width: 20px;background: white"> {{translateText("textMap.", menu.RotatingMachineryGraph.data._610name) }}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/RotatingMachineryGraph/TemperatureiDstributionField"-->
          <!--                          v-show="menu.RotatingMachineryGraph.data['6-17']"><img :src="imgUrl_Xuan_RunS" style="height: 15px;width: 20px;background: white"> {{ translateText("textMap.", menu.RotatingMachineryGraph.data._617name) }}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/RotatingMachineryGraph/RotatingVibrationMonitor"-->
          <!--                          v-show="menu.RotatingMachineryGraph.data['6-1']"><img :src="imgUrl_XuanVib" style="height: 15px;width: 20px;background: white"> {{ translateText("textMap.", menu.RotatingMachineryGraph.data._61name) }}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/RotatingMachineryGraph/VibrationHistoricalComparison"-->
          <!--                          v-show="menu.RotatingMachineryGraph.data['6-2']"><img :src="imgUrl_XuanHisCompare" style="height: 15px;width: 20px;background: white"> {{ translateText("textMap.", menu.RotatingMachineryGraph.data._62name) }}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/RotatingMachineryGraph/OrbitOfShaftCenter1"-->
          <!--                          v-show="menu.RotatingMachineryGraph.data['6-4']"><img :src="imgUrl_XuanZhouG" style="height: 15px;width: 20px;background: white"> {{ translateText("textMap.", menu.RotatingMachineryGraph.data._64name) }}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/RotatingMachineryGraph/AxisPosition" v-show="menu.RotatingMachineryGraph.data['6-5']"><img :src="imgUrl_XuanZhouW" style="height: 15px;width: 20px;background: white"> {{ translateText("textMap.", menu.RotatingMachineryGraph.data._65name) }}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/RotatingMachineryGraph/StartStopGraph"-->
          <!--                          v-show="menu.RotatingMachineryGraph.data['6-6']"><img :src="imgUrl_XuanStartStop" style="height: 15px;width: 20px;background: white"> {{translateText("textMap.", menu.RotatingMachineryGraph.data._66name)}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/RotatingMachineryGraph/RotatingComprehensiveAnalysis"-->
          <!--                          v-show="menu.RotatingMachineryGraph.data['6-7']"><img :src="imgUrl_Xuan_ZongH" style="height: 15px;width: 20px;background: white"> {{translateText("textMap.", menu.RotatingMachineryGraph.data._67name)}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/RotatingMachineryGraph/RotatingRunStatusGraph"-->
          <!--                          v-show="menu.RotatingMachineryGraph.data['6-8']"><img :src="imgUrl_Xuan_RunS" style="height: 15px;width: 20px;background: white"> {{translateText("textMap.", menu.RotatingMachineryGraph.data._68name)}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/RotatingMachineryGraph/OtherParametersTrendGraph2"-->
          <!--                          v-show="menu.RotatingMachineryGraph.data['6-9']"><img :src="imgUrl_Other_Parameters" style="height: 15px;width: 20px;background: white"> {{ translateText("textMap.", menu.RotatingMachineryGraph.data._69name) }}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/RotatingMachineryGraph/WholeSpectrumGraph"-->
          <!--                          v-show="menu.RotatingMachineryGraph.data['6-11']"><img :src="imgUrl_AllS" style="height: 15px;width: 20px;background: white"> {{ translateText("textMap.", menu.RotatingMachineryGraph.data._611name) }}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/RotatingMachineryGraph/TwoDimensionalHolography"-->
          <!--                          v-show="menu.RotatingMachineryGraph.data['6-12']"><img :src="imgUrl_TwoS" style="height: 15px;width: 20px;background: white"> {{menu.RotatingMachineryGraph.data._612name}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/RotatingMachineryGraph/ThreeDimensionalHolography"-->
          <!--                          v-show="menu.RotatingMachineryGraph.data['6-13']"><img :src="imgUrl_ThreeS" style="height: 15px;width: 20px;background: white"> {{menu.RotatingMachineryGraph.data._613name}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/RotatingMachineryGraph/DynamicBalancing"-->
          <!--                          v-show="menu.RotatingMachineryGraph.data['6-14']"><img :src="imgUrl_DPH" style="height: 15px;width: 20px;background: white"> {{menu.RotatingMachineryGraph.data._614name}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/RotatingMachineryGraph/ParameterComparisonQuery"-->
          <!--                          v-show="menu.RotatingMachineryGraph.data['6-16']"><img :src="imgUrl_DPH" style="height: 15px;width: 20px;background: white"> {{translateText("textMap.", menu.RotatingMachineryGraph.data._616name)}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/RotatingMachineryGraph/ImpactDiagnosis"-->
          <!--                          v-show="menu.RotatingMachineryGraph.data['6-18']"><img :src="imgUrl_DPH" style="height: 15px;width: 20px;background: white"> {{translateText("textMap.", menu.RotatingMachineryGraph.data._618name)}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/RotatingMachineryGraph/RotatingCepstrumGraph"-->
          <!--                          v-show="menu.RotatingMachineryGraph.data['6-19']"><img :src="imgUrl_Cepstrum_G" style="height: 15px;width: 20px;background: white">  {{translateText("textMap.", menu.RotatingMachineryGraph.data._619name)}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/RotatingMachineryGraph/SingleMultiBarValueChart"-->
          <!--                            v-show="menu.RotatingMachineryGraph.data['6-3']"><img :src="imgUrl_Single_Multi" style="height: 15px;width: 20px;background: white"> {{ translateText("textMap.", menu.RotatingMachineryGraph.data._63name) }}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/RotatingMachineryGraph/RotatingHistoryTrendGraph"-->
          <!--                          v-show="menu.RotatingMachineryGraph.data['6-20']"><img :src="imgUrl_XuanHisCompare" style="height: 15px;width: 20px;background: white"> {{  translateText("textMap.", menu.RotatingMachineryGraph.data._620name) }}-->
          <!--            </el-menu-item>-->
          <!--            &lt;!&ndash;            <el-menu-item index="6-14" v-show="menu.RotatingMachineryGraph.data['6-14']">现场动平衡</el-menu-item>&ndash;&gt;-->
          <!--          </el-submenu>-->
          <!--          &lt;!&ndash;          <el-submenu index="1" v-show="menu.SpecialManualOfPump.show">&ndash;&gt;-->
          <!--          <el-submenu index="1" :disabled="showManual"  v-show="menu.SpecialManualOfPump.show">-->
          <!--            <template slot="title">{{translateText("textMap.",menu.SpecialManualOfPump.name)}}</template>-->
          <!--            <el-menu-item index="/UnitOverviewMap" v-show="menu.SpecialManualOfPump.data['1']"><img :src="imgUrl_UnitMap" style="height: 15px;width: 20px;background: white">  {{translateText("textMap.", menu.SpecialManualOfPump.data._1name)}}</el-menu-item>-->
          <!--            <el-menu-item index="/AlarmQueryGraph" v-show="menu.SpecialManualOfPump.data['2']"><img :src="imgUrl_Alarm_Q" style="height: 15px;width: 20px;background: white">  {{translateText("textMap.", menu.SpecialManualOfPump.data._2name)}}</el-menu-item>-->
          <!--            <el-menu-item index="/TrendAnalysis" v-show="menu.SpecialManualOfPump.data['3']"><img :src="imgUrl_Trend_A" style="height: 15px;width: 20px;background: white">  {{translateText("textMap.", menu.SpecialManualOfPump.data._3name)}}</el-menu-item>-->
          <!--            <el-menu-item index="/PumpImpactDiagnosis" v-show="menu.SpecialManualOfPump.data['4']"><img :src="imgUrl_Pump_P" style="height: 15px;width: 20px;background: white">  {{translateText("textMap.", menu.SpecialManualOfPump.data._4name)}}</el-menu-item>-->
          <!--            &lt;!&ndash; <el-menu-item index="/VibrationMonitor" v-show="menu.SpecialManualOfPump.data['3']">振动监测</el-menu-item>&ndash;&gt;-->
          <!--            <el-menu-item index="/RotorFaultDiagnosis" v-show="menu.SpecialManualOfPump.data['5']"><img :src="imgUrl_RotorFault_D" style="height: 15px;width: 20px;background: white">  {{translateText("textMap.", menu.SpecialManualOfPump.data._5name)}}</el-menu-item>-->
          <!--            <el-menu-item index="/CepstrumGraph" v-show="menu.SpecialManualOfPump.data['6']"><img :src="imgUrl_Cepstrum_G" style="height: 15px;width: 20px;background: white">  {{translateText("textMap.", menu.SpecialManualOfPump.data._6name)}}</el-menu-item>-->
          <!--            &lt;!&ndash;   <el-menu-item index="/ChangeVisualization" v-show="menu.SpecialManualOfPump.data['5']">变工况可视化</el-menu-item>&ndash;&gt;-->
          <!--            <el-menu-item index="/OtherParametersTrendGraph" v-show="menu.SpecialManualOfPump.data['7']"><img :src="imgUrl_Other_Parameters" style="height: 15px;width: 20px;background: white"> {{translateText("textMap.", menu.SpecialManualOfPump.data._7name)}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/SingleMultiBarValueChart" v-show="menu.SpecialManualOfPump.data['8']"><img :src="imgUrl_Single_Multi" style="height: 15px;width: 20px;background: white"> {{translateText("textMap.", menu.SpecialManualOfPump.data._8name)}}-->
          <!--            </el-menu-item>-->
          <!--            &lt;!&ndash;  <el-menu-item index="/ComprehensiveAnalysis" v-show="menu.SpecialManualOfPump.data['7']">综合分析</el-menu-item>&ndash;&gt;-->
          <!--            &lt;!&ndash;<el-menu-item index="/MultiParametersTrendGraph" v-show="menu.SpecialManualOfPump.data['8']">多参数趋势图</el-menu-item>&ndash;&gt;-->
          <!--            &lt;!&ndash;   <el-menu-item index="/OrbitOfShaftCenter" v-show="menu.SpecialManualOfPump.data['9']">轴心轨迹</el-menu-item>&ndash;&gt;-->
          <!--            &lt;!&ndash; <el-menu-item index="/StartstopGraph" v-show="menu.SpecialManualOfPump.data['11']">启停车对比分析</el-menu-item>-->
          <!--             <el-menu-item index="/RunSwordGraph" v-show="menu.SpecialManualOfPump.data['12']">运行大刀图</el-menu-item>-->
          <!--             <el-menu-item index="/RunStatusGraph" v-show="menu.SpecialManualOfPump.data['13']">运行状态图</el-menu-item>&ndash;&gt;-->
          <!--            <el-menu-item index="/AnalysisGraph" v-show="menu.SpecialManualOfPump.data['14']"><img :src="imgUrl_Alarm_Q" style="height: 15px;width: 20px;background: white">  {{translateText("textMap.", menu.SpecialManualOfPump.data._14name)}}</el-menu-item>-->
          <!--          </el-submenu>-->

          <!--          <el-submenu index="9" :disabled="showWireless" v-show="menu.SpecialManualOfPump1.show">-->
          <!--&lt;!&ndash;                      <el-submenu index="1" :disabled="showManual" v-show="menu.SpecialManualOfPump.show">&ndash;&gt;-->
          <!--            <template slot="title">{{translateText("textMap.", menu.SpecialManualOfPump1.name)}}</template>-->
          <!--            <el-menu-item index="/WirelessPumpGraph/WirelessPumpUnitOverviewMap" v-show="menu.SpecialManualOfPump1.data['1']"><img :src="imgUrl_UnitMap" style="height: 15px;width: 20px;background: white"> {{translateText("textMap.", menu.SpecialManualOfPump1.data._wu1name)}}</el-menu-item>-->
          <!--            <el-menu-item index="/WirelessPumpGraph/WirelessPumpAlarmQueryGraph" v-show="menu.SpecialManualOfPump1.data['2']"><img :src="imgUrl_Alarm_Q" style="height: 15px;width: 20px;background: white"> {{translateText("textMap.", menu.SpecialManualOfPump1.data._wu2name)}}</el-menu-item>-->
          <!--            <el-menu-item index="/WirelessPumpGraph/WirelessPumpTrendAnalysis" v-show="menu.SpecialManualOfPump1.data['3']"><img :src="imgUrl_Trend_A" style="height: 15px;width: 20px;background: white"> {{translateText("textMap.", menu.SpecialManualOfPump1.data._wu3name)}}</el-menu-item>-->
          <!--            <el-menu-item index="/WirelessPumpGraph/WirelessPumpImpactDiagnosis" v-show="menu.SpecialManualOfPump1.data['4']"><img :src="imgUrl_Pump_P" style="height: 15px;width: 20px;background: white"> {{translateText("textMap.", menu.SpecialManualOfPump1.data._wu4name)}}</el-menu-item>-->
          <!--            &lt;!&ndash; <el-menu-item index="/VibrationMonitor" v-show="menu.SpecialManualOfPump.data['3']">振动监测</el-menu-item>&ndash;&gt;-->
          <!--&lt;!&ndash;            <el-menu-item index="/RotorFaultDiagnosis" v-show="menu.SpecialManualOfPump.data['5']">转子类故障诊断</el-menu-item>&ndash;&gt;-->
          <!--&lt;!&ndash;            <el-menu-item index="/CepstrumGraph" v-show="menu.SpecialManualOfPump.data['6']">倒谱图</el-menu-item>&ndash;&gt;-->
          <!--            &lt;!&ndash;   <el-menu-item index="/ChangeVisualization" v-show="menu.SpecialManualOfPump.data['5']">变工况可视化</el-menu-item>&ndash;&gt;-->
          <!--&lt;!&ndash;            <el-menu-item index="/SingleMultiBarValueChart" v-show="menu.SpecialManualOfPump.data['7']">单多值棒图</el-menu-item>&ndash;&gt;-->
          <!--            &lt;!&ndash;  <el-menu-item index="/ComprehensiveAnalysis" v-show="menu.SpecialManualOfPump.data['7']">综合分析</el-menu-item>&ndash;&gt;-->
          <!--            &lt;!&ndash;<el-menu-item index="/MultiParametersTrendGraph" v-show="menu.SpecialManualOfPump.data['8']">多参数趋势图</el-menu-item>&ndash;&gt;-->
          <!--            <el-menu-item index="/WirelessPumpGraph/WirelessPumpOtherParametersTrendGraph" v-show="menu.SpecialManualOfPump1.data['8']"><img :src="imgUrl_Other_P" style="height: 15px;width: 20px;background: white"> {{translateText("textMap.", menu.SpecialManualOfPump1.data._wu8name)}}</el-menu-item>-->
          <!--            <el-menu-item index="/WirelessPumpGraph/WaveformSpectraComparativeAnalysis" v-show="menu.SpecialManualOfPump1.data['9']"><img :src="imgUrl_Other_P" style="height: 15px;width: 20px;background: white"> {{translateText("textMap.", menu.SpecialManualOfPump1.data._wu9name)}}</el-menu-item>-->
          <!--            <el-menu-item index="/WirelessPumpGraph/WirelessPumpEdgeComputingGraph" v-show="menu.SpecialManualOfPump1.data['10']"><img :src="imgUrl_Other_P" style="height: 15px;width: 20px;background: white"> {{translateText("textMap.", menu.SpecialManualOfPump1.data._wu10name)}}</el-menu-item>-->
          <!--            <el-menu-item index="/WirelessPumpGraph/WirelessPumpCepstrumGraph" v-show="menu.SpecialManualOfPump1.data['11']"><img :src="imgUrl_Other_P" style="height: 15px;width: 20px;background: white"> {{translateText("textMap.", menu.SpecialManualOfPump1.data._wu11name)}}</el-menu-item>-->
          <!--            &lt;!&ndash;   <el-menu-item index="/OrbitOfShaftCenter" v-show="menu.SpecialManualOfPump.data['9']">轴心轨迹</el-menu-item>&ndash;&gt;-->
          <!--            &lt;!&ndash; <el-menu-item index="/StartstopGraph" v-show="menu.SpecialManualOfPump.data['11']">启停车对比分析</el-menu-item>-->
          <!--             <el-menu-item index="/RunSwordGraph" v-show="menu.SpecialManualOfPump.data['12']">运行大刀图</el-menu-item>-->
          <!--             <el-menu-item index="/RunStatusGraph" v-show="menu.SpecialManualOfPump.data['13']">运行状态图</el-menu-item>&ndash;&gt;-->
          <!--          </el-submenu>-->
          <!--          <el-submenu index="13" :disabled="showToC" v-show="menu.WirelessToCMachineryGraph.show">-->
          <!--            <template slot="title">{{translateText("textMap.", menu.WirelessToCMachineryGraph.name)}}</template>-->
          <!--            <el-menu-item index="/WirelessToCMachineryGraph/ToCVibrationMonitor" v-show="menu.WirelessToCMachineryGraph.data['1']"><img :src="imgUrl_Trend_A" style="height: 15px;width: 20px;background: white"> {{translateText("textMap.", menu.WirelessToCMachineryGraph.data._wu1name)}}</el-menu-item>-->
          <!--            <el-menu-item index="/WirelessToCMachineryGraph/ToCAlarmQueryGraph" v-show="menu.WirelessToCMachineryGraph.data['2']"><img :src="imgUrl_Alarm_Q" style="height: 15px;width: 20px;background: white"> {{translateText("textMap.", menu.WirelessToCMachineryGraph.data._wu2name)}}</el-menu-item>-->
          <!--          </el-submenu>-->

          <!--          <el-submenu index="11" :disabled="showEscalator" v-show="menu.EscalatorGraph.show">-->
          <!--            <template slot="title">{{menu.EscalatorGraph.name}}</template>-->
          <!--            <el-menu-item index="/EscalatorAlarmQueryGraph" v-show="menu.EscalatorGraph.data['2']"><img :src="imgUrl_Alarm_Q" style="height: 15px;width: 20px;background: white">  {{menu.EscalatorGraph.data._2name}}</el-menu-item>-->
          <!--            <el-menu-item index="/EscalatorTrendAnalysis" v-show="menu.EscalatorGraph.data['3']"><img :src="imgUrl_Trend_A" style="height: 15px;width: 20px;background: white">  {{menu.EscalatorGraph.data._3name}}</el-menu-item>-->
          <!--            <el-menu-item index="/EscalatorPumpImpactDiagnosis" v-show="menu.EscalatorGraph.data['4']"><img :src="imgUrl_Pump_P" style="height: 15px;width: 20px;background: white">  {{menu.EscalatorGraph.data._4name}}</el-menu-item>-->
          <!--            <el-menu-item index="/EscalatorRotorFaultDiagnosis" v-show="menu.EscalatorGraph.data['5']"><img :src="imgUrl_RotorFault_D" style="height: 15px;width: 20px;background: white">  {{menu.EscalatorGraph.data._5name}}</el-menu-item>-->
          <!--            <el-menu-item index="/EscalatorCepstrumGraph" v-show="menu.EscalatorGraph.data['6']"><img :src="imgUrl_Cepstrum_G" style="height: 15px;width: 20px;background: white">  {{menu.EscalatorGraph.data._6name}}</el-menu-item>-->
          <!--            <el-menu-item index="/EscalatorSingleMultiBarValueChart" v-show="menu.EscalatorGraph.data['7']"><img :src="imgUrl_Single_Multi" style="height: 15px;width: 20px;background: white"> {{menu.EscalatorGraph.data._7name}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/EscalatorOtherParametersTrendGraph" v-show="menu.EscalatorGraph.data['8']"><img :src="imgUrl_Other_Parameters" style="height: 15px;width: 20px;background: white"> {{menu.EscalatorGraph.data._8name}}-->
          <!--            </el-menu-item>-->
          <!--          </el-submenu>-->
          <!--          <el-submenu index="12" :disabled="showHeatingFurnace"  v-show="menu.HeatingFurnace.show">-->
          <!--            <template slot="title">{{menu.HeatingFurnace.name}}</template>-->
          <!--            <el-menu-item index="/HeatingFurnaceGraph/HeatingFurnaceUnitOverviewMap" v-show="menu.HeatingFurnace.data['1']"><img :src="imgUrl_UnitMap" style="height: 15px;width: 20px;background: white">  {{menu.HeatingFurnace.data._1name}}</el-menu-item>-->
          <!--            <el-menu-item index="/HeatingFurnaceGraph/HeatingFurnaceOtherParametersTrendGraph" v-show="menu.HeatingFurnace.data['2']"><img :src="imgUrl_Other_Parameters" style="height: 15px;width: 20px;background: white"> {{menu.HeatingFurnace.data._2name}}-->
          <!--            </el-menu-item>-->
          <!--          </el-submenu>-->
          <!--          <el-submenu index="10" :disabled="showGas" v-show="menu.gasTurbineGraph.show">-->
          <!--            <template slot="title">{{translateText("textMap.", menu.gasTurbineGraph.name)}}</template>-->
          <!--            <el-menu-item index="/gasTurbineGraph/GasOverviewGrap"-->
          <!--                          v-show="menu.gasTurbineGraph.data['6-15']"><img :src="imgUrl_Xuan_Map" style="height: 15px;width: 20px;background: white"> {{translateText("textMap.", menu.gasTurbineGraph.data._615name)}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/gasTurbineGraph/AlarmQueryGraph2"-->
          <!--                          v-show="menu.gasTurbineGraph.data['6-10']"><img :src="imgUrl_Alarm_Q" style="height: 15px;width: 20px;background: white"> {{translateText("textMap.", menu.gasTurbineGraph.data._610name)}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/gasTurbineGraph/TemperatureiDstributionField1"-->
          <!--                          v-show="menu.gasTurbineGraph.data['6-16']"><img :src="imgUrl_AllS" style="height: 15px;width: 20px;background: white"> {{translateText("textMap.", menu.gasTurbineGraph.data._616name)}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/gasTurbineGraph/GasVibrationMonitor"-->
          <!--                          v-show="menu.gasTurbineGraph.data['6-1']"><img :src="imgUrl_XuanVib" style="height: 15px;width: 20px;background: white"> {{translateText("textMap.", menu.gasTurbineGraph.data._61name)}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/gasTurbineGraph/VibrationHistoricalComparison"-->
          <!--                          v-show="menu.gasTurbineGraph.data['6-2']"><img :src="imgUrl_XuanHisCompare" style="height: 15px;width: 20px;background: white"> {{translateText("textMap.", menu.gasTurbineGraph.data._62name)}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/gasTurbineGraph/GasSingleMultaBarGraph"-->
          <!--                          v-show="menu.gasTurbineGraph.data['6-3']"><img :src="imgUrl_Single_Multi" style="height: 15px;width: 20px;background: white"> {{translateText("textMap.", menu.gasTurbineGraph.data._63name)}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/gasTurbineGraph/OrbitOfShaftCenter1"-->
          <!--                          v-show="menu.gasTurbineGraph.data['6-4']"><img :src="imgUrl_XuanZhouG" style="height: 15px;width: 20px;background: white"> {{translateText("textMap.", menu.gasTurbineGraph.data._64name)}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/gasTurbineGraph/AxisPosition" v-show="menu.RotatingMachineryGraph.data['6-5']"><img :src="imgUrl_XuanZhouW" style="height: 15px;width: 20px;background: white"> {{translateText("textMap.", menu.gasTurbineGraph.data._65name)}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/gasTurbineGraph/StartStopGraph"-->
          <!--                          v-show="menu.gasTurbineGraph.data['6-6']"><img :src="imgUrl_XuanStartStop" style="height: 15px;width: 20px;background: white"> {{translateText("textMap.", menu.gasTurbineGraph.data._66name)}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/gasTurbineGraph/GasComprehensiveAnalysis"-->
          <!--                          v-show="menu.gasTurbineGraph.data['6-7']"><img :src="imgUrl_Xuan_ZongH" style="height: 15px;width: 20px;background: white"> {{translateText("textMap.", menu.gasTurbineGraph.data._67name)}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/gasTurbineGraph/GasRunStatusGraph"-->
          <!--                          v-show="menu.gasTurbineGraph.data['6-8']"><img :src="imgUrl_Xuan_RunS" style="height: 15px;width: 20px;background: white"> {{translateText("textMap.", menu.gasTurbineGraph.data._68name)}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/gasTurbineGraph/OtherParametersTrendGraph2"-->
          <!--                          v-show="menu.gasTurbineGraph.data['6-9']"><img :src="imgUrl_Other_Parameters" style="height: 15px;width: 20px;background: white"> {{translateText("textMap.", menu.gasTurbineGraph.data._69name)}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/gasTurbineGraph/WholeSpectrumGraph"-->
          <!--                          v-show="menu.gasTurbineGraph.data['6-11']"><img :src="imgUrl_AllS" style="height: 15px;width: 20px;background: white"> {{translateText("textMap.", menu.gasTurbineGraph.data._611name)}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/gasTurbineGraph/TwoDimensionalHolography"-->
          <!--                          v-show="menu.gasTurbineGraph.data['6-12']"><img :src="imgUrl_TwoS" style="height: 15px;width: 20px;background: white"> {{translateText("textMap.", menu.gasTurbineGraph.data._612name)}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/gasTurbineGraph/ThreeDimensionalHolography"-->
          <!--                          v-show="menu.gasTurbineGraph.data['6-13']"><img :src="imgUrl_ThreeS" style="height: 15px;width: 20px;background: white"> {{translateText("textMap.", menu.gasTurbineGraph.data._613name)}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/gasTurbineGraph/DynamicBalancing"-->
          <!--                          v-show="menu.RotatingMachineryGraph.data['6-14']"><img :src="imgUrl_DPH" style="height: 15px;width: 20px;background: white"> {{translateText("textMap.", menu.gasTurbineGraph.data._614name)}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/gasTurbineGraph/ParameterComparisonQuery"-->
          <!--                          v-show="menu.gasTurbineGraph.data['6-17']"><img :src="imgUrl_DPH" style="height: 15px;width: 20px;background: white"> {{translateText("textMap.", menu.gasTurbineGraph.data._617name)}}-->
          <!--            </el-menu-item>-->

          <!--            &lt;!&ndash;            <el-menu-item index="6-14" v-show="menu.RotatingMachineryGraph.data['6-14']">现场动平衡</el-menu-item>&ndash;&gt;-->
          <!--          </el-submenu>-->

          <!--          &lt;!&ndash; <el-submenu index="2" v-if="menu.AlarmStatistics.show">-->
          <!--            <template slot="title">{{menu.AlarmStatistics.name}}</template>-->
          <!--            <el-menu-item index="2-1" v-show="menu.AlarmStatistics.data['2-1']">{{menu.AlarmStatistics.data._21name}}</el-menu-item>-->
          <!--            <el-menu-item index="2-2" v-show="menu.AlarmStatistics.data['2-2']">{{menu.AlarmStatistics.data._22name}}</el-menu-item>-->
          <!--                        <el-menu-item index="2-3">堆内构件诊断分析</el-menu-item>-->
          <!--            <el-menu-item index="2-3" v-show="menu.AlarmStatistics.data['2-3']">{{menu.AlarmStatistics.data._23name}}</el-menu-item>-->
          <!--          </el-submenu> &ndash;&gt;-->
          <!--          <el-menu-item index="/CaseBaseSystem" v-show="menu.CaseBaseSystem.show">{{menu.CaseBaseSystem.name}}</el-menu-item>-->
          <!--          <el-submenu index="3" v-show="menu.ReportOnline.show">-->
          <!--            <template slot="title">{{menu.ReportOnline.name}}</template>-->
          <!--            <el-menu-item index="/3-1" v-show="menu.ReportOnline.data['3-1']">{{menu.ReportOnline.data._31name}}</el-menu-item>-->
          <!--            <el-menu-item index="/FactoryReport" v-show="menu.ReportOnline.data['3-2']">{{menu.ReportOnline.data._32name}}</el-menu-item>-->
          <!--            <el-menu-item index="/MachineMonthReport" v-show="menu.ReportOnline.data['3-3']">{{menu.ReportOnline.data._33name}}</el-menu-item>-->
          <!--            <el-menu-item index="/VibrationParameterReport" v-show="menu.ReportOnline.data['3-4']">{{menu.ReportOnline.data._34name}}</el-menu-item>-->
          <!--          </el-submenu>-->

          <!--          <el-submenu index="7" :disabled="showOffline" v-show="menu.OfflineAnalysis.show">-->
          <!--            <template slot="title">{{menu.OfflineAnalysis.name}}</template>-->
          <!--            <el-menu-item index="/Offline/OLUnitOverviewMap" v-show="menu.OfflineAnalysis.data['7-1']">-->
          <!--              {{menu.OfflineAnalysis.data._71name}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/Offline/OLVibrationTrend"-->
          <!--                          v-show="menu.OfflineAnalysis.data['7-2']">{{menu.OfflineAnalysis.data._72name}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/Offline/OLEnvelopeAnalysis"-->
          <!--                          v-show="menu.OfflineAnalysis.data['7-3']">{{menu.OfflineAnalysis.data._73name}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/Offline/OLRetardedVariablesTrend"-->
          <!--                          v-show="menu.OfflineAnalysis.data['7-4']">{{menu.OfflineAnalysis.data._74name}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/Offline/OLAlarmQueryAnalysis"-->
          <!--                          v-show="menu.OfflineAnalysis.data['7-5']">{{menu.OfflineAnalysis.data._75name}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/Offline/OLComparisonAnalysis" v-show="menu.OfflineAnalysis.data['7-6']">-->
          <!--              {{menu.OfflineAnalysis.data._76name}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/Offline/OLComprehensiveAnalysis"-->
          <!--                          v-show="menu.OfflineAnalysis.data['7-7']">{{menu.OfflineAnalysis.data._77name}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/Offline/OLOrbitOfShaftCenter" v-show="menu.OfflineAnalysis.data['7-8']">-->
          <!--              {{menu.OfflineAnalysis.data._78name}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/Offline/OLManualEntry" v-show="menu.OfflineAnalysis.data['7-9']">-->
          <!--              {{menu.OfflineAnalysis.data._79name}}-->
          <!--            </el-menu-item>-->
          <!--            <el-menu-item index="/Offline/OLWallThicknessTrend"-->
          <!--                          v-show="menu.OfflineAnalysis.data['7-10']">{{menu.OfflineAnalysis.data._710name}}-->
          <!--            </el-menu-item>-->

          <!--          </el-submenu>-->
          <!--          <el-menu-item index="/StatisticOfAlarm" v-show="menu.AlarmStatistics.show">{{menu.AlarmStatistics.name}}</el-menu-item>-->
          <!--          <el-menu-item index="/AnotherStatisticOfAlarm" v-show="menu.AnotherPointState.show">{{menu.AnotherPointState.name}}</el-menu-item>-->
          <!--          <el-submenu index="8" class="another_item" v-show="menu.Admin.show">-->
          <!--            <template slot="title">{{menu.Admin.name}}</template>-->
          <!--            <el-menu-item index="login">切换用户</el-menu-item>-->
          <!--            <el-menu-item index="login">注销</el-menu-item>-->
          <!--          </el-submenu>-->

          <!--        </el-menu>-->

          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            :unique-opened="true"
            menu-trigger="click"
            ref="topMenu"
            :router="false"
            @select="handleSelect"
            @open="handleOpen"
            :background-color="backgroundcolor"
            :text-color="textcolor"
            :active-text-color="activetextcolor">
            <el-menu-item v-for="m in DieselMenus" :key="m.index" :index="m.index" v-show="m.visible && !showDiesel">
              {{ translateText('textMap.', m.label) }}
            </el-menu-item>
            <el-menu-item v-for="m in ReciprocatMenus" :key="m.index" :index="m.index" v-show="m.visible && !showReciprocat">
              {{ translateText('textMap.', m.label) }}
            </el-menu-item>
            <el-menu-item v-for="m in RotatingMenus" :key="m.index" :index="m.index" v-show="m.visible && !showRotating">
              {{ translateText('textMap.', m.label) }}
            </el-menu-item>
            <el-menu-item v-for="m in ManualMenus" :key="m.index" :index="m.index" v-show="m.visible && !showManual">
              {{ translateText('textMap.', m.label) }}
            </el-menu-item>
            <el-menu-item v-for="m in WirelessMenus" :key="m.index" :index="m.index" v-show="m.visible && !showWireless">
              {{ translateText('textMap.', m.label) }}
            </el-menu-item>
            <el-menu-item v-for="m in ToCMenus" :key="m.index" :index="m.index" v-show="m.visible && !showToC">
              {{ translateText('textMap.', m.label) }}
            </el-menu-item>
            <el-menu-item v-for="m in EscalatorMenus" :key="m.index" :index="m.index" v-show="false && m.visible && !showEscalator">
              {{ translateText('textMap.', m.label) }}
            </el-menu-item>
            <el-menu-item v-for="m in FurnaceMenus" :key="m.index" :index="m.index" v-show="m.visible && !showHeatingFurnace">
              {{ translateText('textMap.', m.label) }}
            </el-menu-item>
            <el-menu-item v-for="m in GasMenus" :key="m.index" :index="m.index" v-show="m.visible && !showGas">
              {{ translateText('textMap.', m.label) }}
            </el-menu-item>
            <el-menu-item v-for="m in OfflineMenus" :key="m.index" :index="m.index" v-show="m.visible && !showOffline">
              {{ translateText('textMap.', m.label) }}
            </el-menu-item>
          </el-menu>
        </div>
        <div class="my-div" v-if="showTopic">
          <el-menu
            :default-active="topiccolor"
            class="el-menu-demo"
            mode="horizontal"
            :unique-opened="true"
            menu-trigger="click"
            ref="topMenu1"
            @select="handleTopic"
            @open="handleOpen"
            :background-color="backgroundcolor"
            :text-color="textcolor"
            :active-text-color="activetextcolor">
            <el-submenu index="9" class="another_item" >
              <template slot="title">{{ translateText('textMap.', '更改主题') }}</template>
              <el-menu-item index="quiet-blue">{{ translateText('textMap.', '静谧蓝') }}</el-menu-item>
              <el-menu-item index="simple-white">{{ translateText('textMap.', '默认') }}</el-menu-item>
              <!--            <el-menu-item index="gray">{{ translateText('textMap.', '高级灰') }}</el-menu-item>-->
              <el-menu-item index="high-ash">{{ translateText('textMap.', '暗黑') }}</el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
        <div class="my-div" v-if="showLanguage">
          <el-menu
            :default-active="language"
            class="el-menu-demo"
            mode="horizontal"
            :unique-opened="true"
            menu-trigger="click"
            ref="topMenu2"
            @select="translateLan"
            @open="handleOpen"
            :background-color="backgroundcolor"
            :text-color="textcolor"
            :active-text-color="activetextcolor">
            <el-submenu index="9" class="another_item" >
              <template slot="title">{{ translateText('textMap.', '语言') }}</template>
              <el-menu-item index="zh">{{ translateText('textMap.', '中文') }}</el-menu-item>
              <el-menu-item index="en">{{ translateText('textMap.', '英文') }}</el-menu-item>
              <el-menu-item index="ru">{{ translateText('textMap.', '俄文') }}</el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
      </el-header>
      <el-container class="content">
        <div class="left-aside" id="leftAside" v-show="$store.state.hidden.plantTree">
          <div class="left-title" v-show="showMenu">
            <span class="left-title-txt">{{translateText('textMap.', '组织机构')}}</span>
          </div>
          <div class="left-content" :style="{width: myWidth}" v-show="showMenu">
            <PlantTree class="trees" ref="plant" @handleMenuClose="handleClick" @updateRouter="updateRouter" @changeTopic="changeTopic" @NowEquid="ChangEquId" @fail='datafail'></PlantTree>
          </div>
          <div class="menu-hide">

            <div v-if="showMenu" @click="changeflag" class="op-btn">
              <svg class="op-btn-svg" xmlns="http://www.w3.org/2000/svg" style="flex-shrink: 0;" width="10px" height="66px" viewBox="0 0 10 66" fill="none">
                <path d="M0 0L10 8V58L0 66V0Z" :fill="$store.state.leftconbgcolor"/>
              </svg>
              <svg class="op-btn-svg" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                <path d="M7.36623 1.72184V0.85912C7.36623 0.784343 7.28029 0.743048 7.22225 0.788807L2.191 4.71849C2.14826 4.75174 2.11367 4.79431 2.08987 4.84295C2.06608 4.8916 2.05371 4.94503 2.05371 4.99919C2.05371 5.05334 2.06608 5.10678 2.08987 5.15542C2.11367 5.20407 2.14826 5.24663 2.191 5.27988L7.22225 9.20957C7.28141 9.25533 7.36623 9.21403 7.36623 9.13925V8.27653C7.36623 8.22184 7.34056 8.16939 7.29815 8.13591L3.28029 4.99974L7.29815 1.86247C7.34056 1.82899 7.36623 1.77653 7.36623 1.72184Z" :fill="$store.state.textcolor" fill-opacity="0.85"/>
              </svg>
            </div>
            <div v-else @click="changeflag" class="op-btn">
              <svg class="op-btn-svg" xmlns="http://www.w3.org/2000/svg" width="10" height="66" viewBox="0 0 10 66" fill="none">
                <path d="M0 0L10 8V58L0 66V0Z" :fill="$store.state.leftconbgcolor"/>
              </svg>
              <svg class="op-btn-svg" xmlns="http://www.w3.org/2000/svg" style="flex-shrink: 0;" width="10px" height="10px" viewBox="0 0 10 10" fill="none">
                <path d="M7.83147 4.71901L2.80022 0.789324C2.78708 0.778974 2.77128 0.772542 2.75464 0.770766C2.738 0.76899 2.7212 0.771944 2.70617 0.779286C2.69113 0.786629 2.67847 0.798063 2.66964 0.812276C2.66081 0.826489 2.65617 0.842904 2.65625 0.859636V1.72236C2.65625 1.77705 2.68192 1.8295 2.72433 1.86298L6.74219 5.00026L2.72433 8.13754C2.6808 8.17102 2.65625 8.22348 2.65625 8.27816V9.14089C2.65625 9.21566 2.74219 9.25696 2.80022 9.2112L7.83147 5.28151C7.87424 5.24816 7.90883 5.20549 7.93262 5.15675C7.95642 5.10802 7.96878 5.0545 7.96878 5.00026C7.96878 4.94603 7.95642 4.89251 7.93262 4.84377C7.90883 4.79504 7.87424 4.75237 7.83147 4.71901Z" :fill="$store.state.textcolor" fill-opacity="0.85"/>
              </svg>
            </div>
            <!--          -->
            <!--          <i class="el-icon-caret-left op-button" v-if="showMenu" v-on:click="changeflag"></i>-->
            <!--          <i class="el-icon-caret-right op-button" v-else v-on:click="changeflag"></i>-->
          </div>
        </div>
        <div class="main">

          <keep-alive max="10">
            <router-view
              v-if="$route.meta.keepAlive"
              :key="$route.fullPath"
              @changename='changeunitname'
              @dataloading='dataloading'
              @hideloading='hideloading'
              @datasuccess='datasuccess'
              @datafail='datafail'
              @datanull='datanull'
              @customTip='customTip'
              @brushdatanull="brushdatanull"
              @notEvent="notEvent"
              @notExitPoint="notExitPoint"
              @pointNull='pointNull'
              @tmpDataNull='tmpDataNull'
              @intervalError="intervalError"
              @setinfoname='setnowname'
              @showOpPage='setOpPage'
            ></router-view>
          </keep-alive>

          <router-view
            v-if="!$route.meta.keepAlive"
            @changename='changeunitname'
            @dataloading='dataloading'
            @datasuccess='datasuccess'
            @datafail='datafail'
            @datanull='datanull'
            @customTip='customTip'
            @notEvent="notEvent"
            @notExitPoint="notExitPoint"
            @pointNull='pointNull'
            @tmpDataNull='tmpDataNull'
            @intervalError="intervalError"
            @setinfoname='setnowname'
            @showOpPage='setOpPage'
          ></router-view>

        </div>
        <!--      修改标注弹窗-->
        <div>
          <el-dialog
            :title="translateText('textMap.','请输入标注')"
            :top="upsHeight"
            :modal="false"
            :visible.sync="$store.state.dialogVisible"
            width="20%"
          >
            <el-input size="mini" v-model="$store.state.upsInputValue"></el-input>
            <span slot="footer">
            <el-button size="mini" @click="$store.state.dialogVisible = false">{{translateText('textMap.','取消')}}</el-button>
            <el-button size="mini" type="primary" @click="$store.state.updateGraphicTextFlag = true;$store.state.dialogVisible = false">{{translateText('textMap.','确定')}}</el-button>
          </span>
          </el-dialog>
        </div>
        <!--      数据加载中-->
        <div class="data-loading" ref="load" style="display: block">
          <div class="loadingtext"><i class="el-icon-loading"></i>数据加载中...</div>
        </div>
        <!--      数据获取失败-->
        <div class="datafail" ref="fail" style="display: none">
          <div class="failtext"><i class="el-icon-warning"></i>数据获取失败</div>
        </div>
        <div class="customTip" ref="customTip" style="display: none">
        </div>
        <div class="bearing-info">
          <el-dialog
            :title="translateText('textMap.','计算轴承')"
            :top="bearingInfoHeight"
            :modal="false"
            :visible.sync="$store.state.showBearingDialogFlag"
            width="25%"
          >
            <el-form class="bearing-form" label-position="left">
              <el-form-item :label="translateText('textMap.','轴承型号') + ':'">
                <el-select v-model="BEARING_ID" :placeholder="translateText('textMap.','请选择类型')" filterable size="mini">
                  <el-option
                    v-for="item in $store.state.bearingInfoList"
                    :key="item.BEARING_ID"
                    :label="item.BEARING_ID"
                    :value="item.BEARING_ID">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="translateText('textMap.','转速') + ':'">
                <el-input size="mini" :placeholder="translateText('textMap.', '请输入数字')" @input="onInputNumber" v-model="BEARING_REV">
                  <template #append>r/min</template>
                </el-input>
              </el-form-item>
              <div class="my-form-item-group">
                <el-form-item :label="translateText('textMap.','内圈') + ':'">
                  <span>{{innerValue}}</span>
                </el-form-item>
                <el-form-item :label="translateText('textMap.','滚动体') + ':'" >
                  <span>{{rollingValue}}</span>
                </el-form-item>
              </div>
              <div class="my-form-item-group">
                <el-form-item :label="translateText('textMap.','外圈') + ':'" >
                  <span>{{outerValue}}</span>
                </el-form-item>
                <el-form-item :label="translateText('textMap.','保持架') + ':'">
                  <span>{{cageValue}}</span>
                </el-form-item>
              </div>
              <el-form-item :label="translateText('textMap.','内圈特征频率') + ':'">
                <span>{{fi}}</span>
                <span v-show="fi"> HZ</span>
              </el-form-item>
              <el-form-item :label="translateText('textMap.','外圈特征频率') + ':'">
                <span>{{fo}}</span>
                <span v-show="fo"> HZ</span>
              </el-form-item>
              <el-form-item :label="translateText('textMap.','滚动体特征频率') + ':'">
                <span>{{fe}}</span>
                <span v-show="fe"> HZ</span>
              </el-form-item>
              <el-form-item :label="translateText('textMap.','保持架特征频率') + ':'">
                <span>{{fc}}</span>
                <span v-show="fc"> HZ</span>
              </el-form-item>
            </el-form>
            <span slot="footer">
            <el-button size="mini" type="primary" @click="getBearingInfo()">{{translateText('textMap.','查询')}}</el-button>
          </span>
          </el-dialog>
        </div>

        <div class="event-info">
          <el-dialog
            :title="translateText('textMap.','基准数据信息')"
            :top="BenchmarkInformationHeight"
            :modal="true"
            :close-on-click-modal="false"
            :visible.sync="$store.state.showEventDialogFlag"
            width="50%"
            :style="{
              '--dialog-bgcolor': $store.state.leftconbgcolor,
              '--dialog-textcolor': dialogTextColor,
              '--dialog-bordercolor': dialogBorderColor,
              '--dialog-input-bordercolor': dialogBorderColor,
              '--dialog-btncolor': $store.state.buttoncolor,
              '--dialog-placeholder-color': dialogTextColor + '80',
              '--dialog-focus-color': $store.state.buttoncolor,
              '--dialog-divider-color': dialogBorderColor
            }"
          >
            <el-form
              class="event-form"
              label-position="left"
              :model="$store.state"
              :rules="eventFormRules"
              ref="eventForm"
            >
              <el-form-item
                :label="translateText('textMap.','基准数据名称') + ':'" prop="eventName"
              >
                <el-input
                  size="default"
                  :placeholder="translateText('textMap.', '请输入基准数据名称')"
                  v-model="$store.state.eventName"
                  :style="{
                    backgroundColor: $store.state.inputbgcolor,
                    color: dialogTextColor,
                    borderRadius: '4px'
                  }"
                >
                </el-input>
              </el-form-item>
              <el-form-item :label="translateText('textMap.','采集时间') + ':'">
                <div
                  :style="{
                    color: dialogTextColor,
                    fontSize: '14px',
                    lineHeight: '30px',
                  }"
                >
                  {{ new Date($store.state.postData.markTime).toLocaleString() }}
                </div>
              </el-form-item>
              <el-form-item :label="translateText('textMap.','转速') + ':'">
                <div
                  :style="{
                    color: dialogTextColor,
                    fontSize: '14px',
                    lineHeight: '30px',
                  }"
                >
                  {{ $store.state.currentRev + ' r/min' }}
                </div>
              </el-form-item>
              <el-form-item :label="translateText('textMap.','备注') + ':'">
                <el-input
                  size="default"
                  type="textarea"
                  :placeholder="translateText('textMap.', '请输入备注信息')"
                  v-model="$store.state.eventDescription"
                  rows="3"
                  :style="{
                    backgroundColor: $store.state.inputbgcolor,
                    color: dialogTextColor,
                    borderRadius: '4px',
                    resize: 'vertical'
                  }"
                  maxlength="100"
                  show-word-limit
                  :word-limit="{ show: true }"
                >
                </el-input>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button
                @click="closeEventDialog"
                size="small"
                :style="getDialogButtonStyle('cancel')"
              >{{ translateText('textMap.', '取消') }}</el-button>
              <el-button
                type="primary"
                @click="saveChartParameter()"
                :loading="saveLoading"
                :disabled="saveLoading"
                size="small"
                :style="getDialogButtonStyle('confirm')"
              >{{ saveLoading ? translateText('textMap.', '保存中') : translateText('textMap.', '确定') }}</el-button>
            </span>
          </el-dialog>
        </div>
      </el-container>
    </el-container>
  </div>

</template>

<script>
import event from "../assets/event";
import PlantTree from "../components/ComUtils/PlantTree";
import en from 'element-ui/lib/locale/lang/en'
import zh from 'element-ui/lib/locale/lang/zh-CN'
import ru from 'element-ui/lib/locale/lang/ru-RU'
import locale from 'element-ui/lib/locale'
import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';
import {parse} from 'papaparse';
import {exportToExcel} from '../js/ExportPhrasesToExcel';

var elementResizeDetectorMaker = require("element-resize-detector");

export default {
  // props:[username],
  name: "Home",
  data() {
    return {
      saveLoading: false,
      eventFormRules: {
        eventName: [
          {required: true, message: '请输入基准数据名称', trigger: 'blur'}
        ]
      },
      imgUrl_UnitMap: require("../assets/unitmap.png"),
      imgUrl_Alarm_Q: require("../assets/Alarm_Q.png"),
      imgUrl_Trend_A: require("../assets/Trend_A.png"),
      imgUrl_Pump_P: require("../assets/Pump_P.png"),
      imgUrl_Other_P: require("../assets/Other_P.png"),
      imgUrl_RotorFault_D: require("../assets/RotorFault_D.png"),
      imgUrl_Cepstrum_G: require("../assets/Cepstrum_G.png"),
      imgUrl_Single_Multi: require("../assets/Single_Multi.png"),
      imgUrl_Other_Parameters: require("../assets/Other_Parameters.png"),
      imgUrl_Xuan_Map: require("../assets/Xuan_Map.png"),
      imgUrl_XuanVib: require("../assets/XuanVib.png"),
      imgUrl_XuanHisCompare: require("../assets/Xuan_HisCompare.png"),
      imgUrl_XuanZhouG: require("../assets/Xuan_ZongH.png"),
      imgUrl_XuanZhouW: require("../assets/Xuan_ZhouW.png"),
      imgUrl_XuanStartStop: require("../assets/Xuan_StartStop.png"),
      imgUrl_Xuan_ZongH: require("../assets/Xuan_ZongH.png"),
      imgUrl_Xuan_RunS: require("../assets/Xuan_RunS.png"),
      imgUrl_AllS: require("../assets/Xuan_AllS.png"),
      imgUrl_TwoS: require("../assets/Xuan_TwoS.png"),
      imgUrl_ThreeS: require("../assets/Xuan_ThreeS.png"),
      imgUrl_DPH: require("../assets/Xuan_DPH.png"),
      imgUrl_WangFM: require("../assets/WangFM.png"),
      imgUrl_Wang_HBai: require("../assets/Wang_HBai.png"),
      imgUrl_Wang_HGuiJi: require("../assets/WangHGuiJi.png"),
      imgUrl_Wang_SG: require("../assets/WangSG.png"),
      imgUrl_Wang_YJ: require("../assets/Wang_YJ.png"),
      imgUrl_Wang_DCS: require("../assets/Wang_DCS.png"),
      nowwidth: (window.screen.width - 270) + 'px',
      // menu: config.menu,
      bookImg: require('@/assets/BH.png'),
      showMenu: true,
      equid: '',
      nowpos: '',
      nowWidth: 0,
      nowHeight: 0,
      nowOpenedIndex: 0,
      isOpened: false,

      myWidth: '230px',
      pathFlag: config.menu.interface,
      tmpmenu: config.menu,
      BEARING_ID: this.$store.state.BEARING_ID,//轴承编号
      BEARING_REV: '',//转速
      innerValue: this.$store.state.innerValue,//内圈
      rollingValue: this.$store.state.rollingValue,//滚动体
      outerValue: this.$store.state.outerValue,//外圈
      cageValue: this.$store.state.cageValue,//保持架
      fi: this.$store.state.fi,//内圈旋转频率
      fo: this.$store.state.fo,//外圈故障特征频率
      fe: this.$store.state.fe,//滚动体故障特征频率
      fc: this.$store.state.fc,//保持架故障特征频率
      DieselMenus: [
        {
          index: '/DieselMonitorSystem/OverviewGraph',
          label: config.menu.DieselMonitorSystem.data._51name,
          // 权限或开关（原先的 v-show 条件）
          visible: config.menu.DieselMonitorSystem.data['5-1']
        },
        {
          index: '/DieselMonitorSystem/DieselMonitorRunStatus',
          label: config.menu.DieselMonitorSystem.data._52name,
          visible: config.menu.DieselMonitorSystem.data['5-2']
        },
        {
          index: '/DieselMonitorSystem/HistoricalComparisonGraph',
          label: config.menu.DieselMonitorSystem.data._53name,
          visible: config.menu.DieselMonitorSystem.data['5-3']
        },
        {
          index: '/DieselMonitorSystem/SingleValueStickGraph',
          label: config.menu.DieselMonitorSystem.data._54name,
          visible: config.menu.DieselMonitorSystem.data['5-4']
        },
        {
          index: '/DieselMonitorSystem/DynamicPressureMonitorGraph',
          label: config.menu.DieselMonitorSystem.data._55name,
          visible: config.menu.DieselMonitorSystem.data['5-5']
        },
        {
          index: '/DieselMonitorSystem/EventQueryGraph',
          label: config.menu.DieselMonitorSystem.data._57name,
          visible: config.menu.DieselMonitorSystem.data['5-7']
        },
        {
          index: '/DieselMonitorSystem/VibrationMonitorGraph',
          label: config.menu.DieselMonitorSystem.data._58name,
          visible: config.menu.DieselMonitorSystem.data['5-8']
        },
        {
          index: '/DieselMonitorSystem/InstantaneousSpeed',
          label: config.menu.DieselMonitorSystem.data._59name,
          visible: config.menu.DieselMonitorSystem.data['5-9']
        },
        {
          index: '/DieselMonitorSystem/TorsionalVibration',
          label: config.menu.DieselMonitorSystem.data._511name,
          visible: config.menu.DieselMonitorSystem.data['5-11']
        },
        {
          index: '/DieselMonitorSystem/MultiparameterAnalysis',
          label: config.menu.DieselMonitorSystem.data._512name,
          visible: config.menu.DieselMonitorSystem.data['5-12']
        },
        {
          index: '/DieselMonitorSystem/ComprehensiveAnalysisGraph',
          label: config.menu.DieselMonitorSystem.data._514name,
          visible: config.menu.DieselMonitorSystem.data['5-14']
        },
        {
          index: '/DieselMonitorSystem/IndicatorGraph',
          label: config.menu.DieselMonitorSystem.data._516name,
          visible: config.menu.DieselMonitorSystem.data['5-16']
        },
        {
          index: '/DieselMonitorSystem/ImpactDiagnosis',
          label: config.menu.DieselMonitorSystem.data._517name,
          visible: config.menu.DieselMonitorSystem.data['5-17']
        },
        {
          index: '/DieselMonitorSystem/OtherParametersTrend',
          label: config.menu.DieselMonitorSystem.data._518name,
          visible: config.menu.DieselMonitorSystem.data['5-18']
        },
        {
          index: '/DieselMonitorSystem/AlarmQuery',
          label: config.menu.DieselMonitorSystem.data._519name,
          visible: config.menu.DieselMonitorSystem.data['5-19']
        },
        {
          index: '/DieselMonitorSystem/OnAndOffStateAnalysis',
          label: config.menu.DieselMonitorSystem.data._521name,
          visible: config.menu.DieselMonitorSystem.data['5-21']
        },
        {
          index: '/DieselMonitorSystem/StartAndStopTimeQuery',
          label: config.menu.DieselMonitorSystem.data._522name,
          visible: config.menu.DieselMonitorSystem.data['5-22']
        }
      ],
      ReciprocatMenus: [
        {
          index: '/ReciprocatMachineryGraph/OverviewGraph1',
          label: config.menu.ReciprocatMachineryGraph.data._41name,
          visible: config.menu.ReciprocatMachineryGraph.data['4-1']
        },
        {
          index: '/ReciprocatMachineryGraph/ReciprocatAlarmQuery',
          label: config.menu.ReciprocatMachineryGraph.data._42name,
          visible: config.menu.ReciprocatMachineryGraph.data['4-2']
        },
        {
          index: '/ReciprocatMachineryGraph/ReciprocatVibrationMonitor',
          label: config.menu.ReciprocatMachineryGraph.data._43name,
          visible: config.menu.ReciprocatMachineryGraph.data['4-3']
        },
        {
          index: '/ReciprocatMachineryGraph/HistoricalComparisonGraph1',
          label: config.menu.ReciprocatMachineryGraph.data._44name,
          visible: config.menu.ReciprocatMachineryGraph.data['4-4']
        },
        {
          index: '/ReciprocatMachineryGraph/PistonRodSettlement',
          label: config.menu.ReciprocatMachineryGraph.data._45name,
          visible: config.menu.ReciprocatMachineryGraph.data['4-5']
        },
        {
          index: '/ReciprocatMachineryGraph/IndicatorGraph1',
          label: config.menu.ReciprocatMachineryGraph.data._46name,
          visible: config.menu.ReciprocatMachineryGraph.data['4-6']
        },
        {
          index: '/ReciprocatMachineryGraph/StressMonitoring',
          label: config.menu.ReciprocatMachineryGraph.data._47name,
          visible: config.menu.ReciprocatMachineryGraph.data['4-7']
        },
        {
          index: '/ReciprocatMachineryGraph/RunStatusGraph1',
          label: config.menu.ReciprocatMachineryGraph.data._48name,
          visible: config.menu.ReciprocatMachineryGraph.data['4-8']
        },
        {
          index: '/ReciprocatMachineryGraph/MultiparameterAnalysis1',
          label: config.menu.ReciprocatMachineryGraph.data._49name,
          visible: config.menu.ReciprocatMachineryGraph.data['4-9']
        },
        {
          index: '/ReciprocatMachineryGraph/OtherParametersTrend1',
          label: config.menu.ReciprocatMachineryGraph.data._410name,
          visible: config.menu.ReciprocatMachineryGraph.data['4-10']
        },
        {
          index: '/ReciprocatMachineryGraph/SingleValueStickGraph1',
          label: config.menu.ReciprocatMachineryGraph.data._411name,
          visible: config.menu.ReciprocatMachineryGraph.data['4-11']
        },
        {
          index: '/ReciprocatMachineryGraph/ReciprocatComprehensiveAnalysis',
          label: config.menu.ReciprocatMachineryGraph.data._412name,
          visible: config.menu.ReciprocatMachineryGraph.data['4-12']
        },
        {
          index: '/ReciprocatMachineryGraph/PistonRodTrackGraph',
          label: config.menu.ReciprocatMachineryGraph.data._413name,
          visible: config.menu.ReciprocatMachineryGraph.data['4-13']
        },
        {
          index: '/ReciprocatMachineryGraph/ReciprocatImpactDiagnosis',
          label: config.menu.ReciprocatMachineryGraph.data._414name,
          visible: config.menu.ReciprocatMachineryGraph.data['4-14']
        },
        {
          index: '/ReciprocatMachineryGraph/ReciprocatSpectraWaterfall',
          label: config.menu.ReciprocatMachineryGraph.data._415name,
          visible: config.menu.ReciprocatMachineryGraph.data['4-15']
        }

      ],
      RotatingMenus: [
        {
          index: '/RotatingMachineryGraph/RotatingOverviewGrap',
          label: config.menu.RotatingMachineryGraph.data._615name,
          visible: config.menu.RotatingMachineryGraph.data['6-15']
        },
        {
          index: '/RotatingMachineryGraph/AlarmQueryGraph2',
          label: config.menu.RotatingMachineryGraph.data._610name,
          visible: config.menu.RotatingMachineryGraph.data['6-10']
        },
        {
          index: '/RotatingMachineryGraph/TemperatureiDstributionField',
          label: config.menu.RotatingMachineryGraph.data._617name,
          visible: config.menu.RotatingMachineryGraph.data['6-17']
        },
        {
          index: '/RotatingMachineryGraph/RotatingVibrationMonitor',
          label: config.menu.RotatingMachineryGraph.data._61name,
          visible: config.menu.RotatingMachineryGraph.data['6-1']
        },
        {
          index: '/RotatingMachineryGraph/VibrationHistoricalComparison',
          label: config.menu.RotatingMachineryGraph.data._62name,
          visible: config.menu.RotatingMachineryGraph.data['6-2']
        },
        {
          index: '/RotatingMachineryGraph/OrbitOfShaftCenter1',
          label: config.menu.RotatingMachineryGraph.data._64name,
          visible: config.menu.RotatingMachineryGraph.data['6-4']
        },
        {
          index: '/RotatingMachineryGraph/AxisPosition',
          label: config.menu.RotatingMachineryGraph.data._65name,
          visible: config.menu.RotatingMachineryGraph.data['6-5']
        },
        {
          index: '/RotatingMachineryGraph/StartStopGraph',
          label: config.menu.RotatingMachineryGraph.data._66name,
          visible: config.menu.RotatingMachineryGraph.data['6-6']
        },
        {
          index: '/RotatingMachineryGraph/RotatingComprehensiveAnalysis',
          label: config.menu.RotatingMachineryGraph.data._67name,
          visible: config.menu.RotatingMachineryGraph.data['6-7']
        },
        {
          index: '/RotatingMachineryGraph/RotatingRunStatusGraph',
          label: config.menu.RotatingMachineryGraph.data._68name,
          visible: config.menu.RotatingMachineryGraph.data['6-8']
        },
        {
          index: '/RotatingMachineryGraph/OtherParametersTrendGraph2',
          label: config.menu.RotatingMachineryGraph.data._69name,
          visible: config.menu.RotatingMachineryGraph.data['6-9']
        },
        {
          index: '/RotatingMachineryGraph/WholeSpectrumGraph',
          label: config.menu.RotatingMachineryGraph.data._611name,
          visible: config.menu.RotatingMachineryGraph.data['6-11']
        },
        {
          index: '/RotatingMachineryGraph/TwoDimensionalHolography',
          label: config.menu.RotatingMachineryGraph.data._612name,
          visible: config.menu.RotatingMachineryGraph.data['6-12']
        },
        {
          index: '/RotatingMachineryGraph/ThreeDimensionalHolography',
          label: config.menu.RotatingMachineryGraph.data._613name,
          visible: config.menu.RotatingMachineryGraph.data['6-13']
        },
        {
          index: '/RotatingMachineryGraph/DynamicBalancing',
          label: config.menu.RotatingMachineryGraph.data._614name,
          visible: config.menu.RotatingMachineryGraph.data['6-14']
        },
        {
          index: '/RotatingMachineryGraph/ParameterComparisonQuery',
          label: config.menu.RotatingMachineryGraph.data._616name,
          visible: config.menu.RotatingMachineryGraph.data['6-16']
        },
        {
          index: '/RotatingMachineryGraph/ImpactDiagnosis',
          label: config.menu.RotatingMachineryGraph.data._618name,
          visible: config.menu.RotatingMachineryGraph.data['6-18']
        },
        {
          index: '/RotatingMachineryGraph/RotatingCepstrumGraph',
          label: config.menu.RotatingMachineryGraph.data._619name,
          visible: config.menu.RotatingMachineryGraph.data['6-19']
        },
        {
          index: '/RotatingMachineryGraph/SingleMultiBarValueChart',
          label: config.menu.RotatingMachineryGraph.data._63name,
          visible: config.menu.RotatingMachineryGraph.data['6-3']
        },
        {
          index: '/RotatingMachineryGraph/RotatingHistoryTrendGraph',
          label: config.menu.RotatingMachineryGraph.data._620name,
          visible: config.menu.RotatingMachineryGraph.data['6-20']
        },
        {
          index: '/RotatingMachineryGraph/RotatingSpectraWaterfall',
          label: config.menu.RotatingMachineryGraph.data._621name,
          visible: config.menu.RotatingMachineryGraph.data['6-21']
        },
      ],
      ManualMenus: [
        {
          index: '/UnitOverviewMap',
          label: config.menu.SpecialManualOfPump.data._1name,
          visible: config.menu.SpecialManualOfPump.data['1']
        },
        {
          index: '/AlarmQueryGraph',
          label: config.menu.SpecialManualOfPump.data._2name,
          visible: config.menu.SpecialManualOfPump.data['2']
        },
        {
          index: '/TrendAnalysis',
          label: config.menu.SpecialManualOfPump.data._3name,
          visible: config.menu.SpecialManualOfPump.data['3']
        },
        {
          index: '/PumpImpactDiagnosis',
          label: config.menu.SpecialManualOfPump.data._4name,
          visible: config.menu.SpecialManualOfPump.data['4']
        },
        {
          index: '/RotorFaultDiagnosis',
          label: config.menu.SpecialManualOfPump.data._5name,
          visible: config.menu.SpecialManualOfPump.data['5']
        },
        {
          index: '/CepstrumGraph',
          label: config.menu.SpecialManualOfPump.data._6name,
          visible: config.menu.SpecialManualOfPump.data['6']
        },
        {
          index: '/OtherParametersTrendGraph',
          label: config.menu.SpecialManualOfPump.data._7name,
          visible: config.menu.SpecialManualOfPump.data['7']
        },
        {
          index: '/SingleMultiBarValueChart',
          label: config.menu.SpecialManualOfPump.data._8name,
          visible: config.menu.SpecialManualOfPump.data['8']
        },
        {
          index: '/WaveformSpectraComparativeAnalysis',
          label: config.menu.SpecialManualOfPump.data._10name,
          visible: config.menu.SpecialManualOfPump.data['10']
        },
        {
          index: '/SpectraWaterfall',
          label: config.menu.SpecialManualOfPump.data._11name,
          visible: config.menu.SpecialManualOfPump.data['11']
        },
        {
          index: '/AnalysisGraph',
          label: config.menu.SpecialManualOfPump.data._14name,
          visible: config.menu.SpecialManualOfPump.data['14']
        },
      ],
      WirelessMenus: [
        {
          index: '/WirelessPumpGraph/WirelessPumpUnitOverviewMap',
          label: config.menu.SpecialManualOfPump1.data._wu1name,
          visible: config.menu.SpecialManualOfPump1.data['1']
        },
        {
          index: '/WirelessPumpGraph/WirelessPumpAlarmQueryGraph',
          label: config.menu.SpecialManualOfPump1.data._wu2name,
          visible: config.menu.SpecialManualOfPump1.data['2']
        },
        {
          index: '/WirelessPumpGraph/WirelessPumpTrendAnalysis',
          label: config.menu.SpecialManualOfPump1.data._wu3name,
          visible: config.menu.SpecialManualOfPump1.data['3']
        },
        {
          index: '/WirelessPumpGraph/WirelessPumpImpactDiagnosis',
          label: config.menu.SpecialManualOfPump1.data._wu4name,
          visible: config.menu.SpecialManualOfPump1.data['4']
        },
        {
          index: '/WirelessPumpGraph/WirelessPumpOtherParametersTrendGraph',
          label: config.menu.SpecialManualOfPump1.data._wu8name,
          visible: config.menu.SpecialManualOfPump1.data['8']
        },
        {
          index: '/WirelessPumpGraph/WaveformSpectraComparativeAnalysis',
          label: config.menu.SpecialManualOfPump1.data._wu9name,
          visible: config.menu.SpecialManualOfPump1.data['9']
        },
        {
          index: '/WirelessPumpGraph/WirelessPumpEdgeComputingGraph',
          label: config.menu.SpecialManualOfPump1.data._wu10name,
          visible: config.menu.SpecialManualOfPump1.data['10']
        },
        {
          index: '/WirelessPumpGraph/WirelessPumpCepstrumGraph',
          label: config.menu.SpecialManualOfPump1.data._wu11name,
          visible: config.menu.SpecialManualOfPump1.data['11']
        },
        {
          index: '/WirelessPumpGraph/WirelessPumpSpectraWaterfall',
          label: config.menu.SpecialManualOfPump1.data._wu12name,
          visible: config.menu.SpecialManualOfPump1.data['12']
        }
      ],
      ToCMenus: [
        {
          index: '/WirelessToCMachineryGraph/ToCVibrationMonitor',
          label: config.menu.WirelessToCMachineryGraph.data._wu1name,
          visible: config.menu.WirelessToCMachineryGraph.data['1']
        },
        {
          index: '/WirelessToCMachineryGraph/ToCAlarmQueryGraph',
          label: config.menu.WirelessToCMachineryGraph.data._wu2name,
          visible: config.menu.WirelessToCMachineryGraph.data['2']
        }
      ],
      EscalatorMenus: [
        {
          index: '/EscalatorAlarmQueryGraph',
          label: config.menu.EscalatorGraph.data._2name,
          visible: config.menu.EscalatorGraph.data['2']
        },
        {
          index: '/EscalatorTrendAnalysis',
          label: config.menu.EscalatorGraph.data._3name,
          visible: config.menu.EscalatorGraph.data['3']
        },
        {
          index: '/EscalatorPumpImpactDiagnosis',
          label: config.menu.EscalatorGraph.data._4name,
          visible: config.menu.EscalatorGraph.data['4']
        },
        {
          index: '/EscalatorRotorFaultDiagnosis',
          label: config.menu.EscalatorGraph.data._5name,
          visible: config.menu.EscalatorGraph.data['5']
        },
        {
          index: '/EscalatorCepstrumGraph',
          label: config.menu.EscalatorGraph.data._6name,
          visible: config.menu.EscalatorGraph.data['6']
        },
        {
          index: '/EscalatorSingleMultiBarValueChart',
          label: config.menu.EscalatorGraph.data._7name,
          visible: config.menu.EscalatorGraph.data['7']
        },
        {
          index: '/EscalatorOtherParametersTrendGraph',
          label: config.menu.EscalatorGraph.data._8name,
          visible: config.menu.EscalatorGraph.data['8']
        }
      ],
      FurnaceMenus: [
        {
          index: '/HeatingFurnaceGraph/HeatingFurnaceUnitOverviewMap',
          label: config.menu.HeatingFurnace.data._1name,
          visible: config.menu.HeatingFurnace.data['1']
        },
        {
          index: '/HeatingFurnaceGraph/HeatingFurnaceOtherParametersTrendGraph',
          label: config.menu.HeatingFurnace.data._2name,
          visible: config.menu.HeatingFurnace.data['2']
        }
      ],
      GasMenus: [
        {
          index: '/gasTurbineGraph/GasOverviewGrap',
          label: config.menu.gasTurbineGraph.data._615name,
          visible: config.menu.gasTurbineGraph.data['6-15']
        },
        {
          index: '/gasTurbineGraph/AlarmQueryGraph2',
          label: config.menu.gasTurbineGraph.data._610name,
          visible: config.menu.gasTurbineGraph.data['6-10']
        },
        {
          index: '/gasTurbineGraph/TemperatureiDstributionField1',
          label: config.menu.gasTurbineGraph.data._616name,
          visible: config.menu.gasTurbineGraph.data['6-16']
        },
        {
          index: '/gasTurbineGraph/GasVibrationMonitor',
          label: config.menu.gasTurbineGraph.data._61name,
          visible: config.menu.gasTurbineGraph.data['6-1']
        },
        {
          index: '/gasTurbineGraph/VibrationHistoricalComparison',
          label: config.menu.gasTurbineGraph.data._62name,
          visible: config.menu.gasTurbineGraph.data['6-2']
        },
        {
          index: '/gasTurbineGraph/GasSingleMultaBarGraph',
          label: config.menu.gasTurbineGraph.data._63name,
          visible: config.menu.gasTurbineGraph.data['6-3']
        },
        {
          index: '/gasTurbineGraph/OrbitOfShaftCenter1',
          label: config.menu.gasTurbineGraph.data._64name,
          visible: config.menu.gasTurbineGraph.data['6-4']
        },
        {
          index: '/gasTurbineGraph/AxisPosition',
          label: config.menu.gasTurbineGraph.data._65name,
          visible: config.menu.gasTurbineGraph.data['6-5']
        },
        {
          index: '/gasTurbineGraph/StartStopGraph',
          label: config.menu.gasTurbineGraph.data._66name,
          visible: config.menu.gasTurbineGraph.data['6-6']
        },
        {
          index: '/gasTurbineGraph/GasComprehensiveAnalysis',
          label: config.menu.gasTurbineGraph.data._67name,
          visible: config.menu.gasTurbineGraph.data['6-7']
        },
        {
          index: '/gasTurbineGraph/GasRunStatusGraph',
          label: config.menu.gasTurbineGraph.data._68name,
          visible: config.menu.gasTurbineGraph.data['6-8']
        },
        {
          index: '/gasTurbineGraph/OtherParametersTrendGraph2',
          label: config.menu.gasTurbineGraph.data._69name,
          visible: config.menu.gasTurbineGraph.data['6-9']
        },
        {
          index: '/gasTurbineGraph/WholeSpectrumGraph',
          label: config.menu.gasTurbineGraph.data._611name,
          visible: config.menu.gasTurbineGraph.data['6-11']
        },
        {
          index: '/gasTurbineGraph/TwoDimensionalHolography',
          label: config.menu.gasTurbineGraph.data._612name,
          visible: config.menu.gasTurbineGraph.data['6-12']
        },
        {
          index: '/gasTurbineGraph/ThreeDimensionalHolography',
          label: config.menu.gasTurbineGraph.data._613name,
          visible: config.menu.gasTurbineGraph.data['6-13']
        },
        {
          index: '/gasTurbineGraph/DynamicBalancing',
          label: config.menu.gasTurbineGraph.data._614name,
          visible: config.menu.RotatingMachineryGraph.data['6-14']
        },
        {
          index: '/gasTurbineGraph/ParameterComparisonQuery',
          label: config.menu.gasTurbineGraph.data._617name,
          visible: config.menu.gasTurbineGraph.data['6-17']
        }
      ],
      OfflineMenus: [
        {
          index: '/Offline/OLUnitOverviewMap',
          label: config.menu.OfflineAnalysis.data._71name,
          visible: config.menu.OfflineAnalysis.data['7-1']
        },
        {
          index: '/Offline/OLVibrationTrend',
          label: config.menu.OfflineAnalysis.data._72name,
          visible: config.menu.OfflineAnalysis.data['7-2']
        },
        {
          index: '/Offline/OLEnvelopeAnalysis',
          label: config.menu.OfflineAnalysis.data._73name,
          visible: config.menu.OfflineAnalysis.data['7-3']
        },
        {
          index: '/Offline/OLRetardedVariablesTrend',
          label: config.menu.OfflineAnalysis.data._74name,
          visible: config.menu.OfflineAnalysis.data['7-4']
        },
        {
          index: '/Offline/OLAlarmQueryAnalysis',
          label: config.menu.OfflineAnalysis.data._75name,
          visible: config.menu.OfflineAnalysis.data['7-5']
        },
        {
          index: '/Offline/OLComparisonAnalysis',
          label: config.menu.OfflineAnalysis.data._76name,
          visible: config.menu.OfflineAnalysis.data['7-6']
        },
        {
          index: '/Offline/OLComprehensiveAnalysis',
          label: config.menu.OfflineAnalysis.data._77name,
          visible: config.menu.OfflineAnalysis.data['7-7']
        },
        {
          index: '/Offline/OLOrbitOfShaftCenter',
          label: config.menu.OfflineAnalysis.data._78name,
          visible: config.menu.OfflineAnalysis.data['7-8']
        },
        {
          index: '/Offline/OLManualEntry',
          label: config.menu.OfflineAnalysis.data._79name,
          visible: config.menu.OfflineAnalysis.data['7-9']
        },
        {
          index: '/Offline/OLWallThicknessTrend',
          label: config.menu.OfflineAnalysis.data._710name,
          visible: config.menu.OfflineAnalysis.data['7-10']
        }
      ]
    }
  },

  mounted() {
    event.$on('setOpPage', (val) => {
      this.setOpPage(val);
    });
    let tempId = setTimeout(() => {
      let intervalId = setInterval(() => { // 定时关闭弹窗
        this.closePromptBox();
      }, 5000);
    }, 5000);

    // let that = this;
    // document.addEventListener('click', (e) => {
    //   let _that = that;
    //   that.$nextTick(() => {
    //     console.log('我的点击区域', e, _that.myopen, e.target.toString());
    //   })
    //   if(e.target.toString().indexOf('el-submenu__title') == -1 && that.isOpened) {
    //      that.$refs.topMenu.close(that.nowOpenedIndex.toString());
    //      that.isOpened = false;
    //   }
    // })
    if (document.getElementById("lefttupu")) {
      var erd = elementResizeDetectorMaker();
      var plantHeight = elementResizeDetectorMaker();
      let that = this;
      that.$nextTick(() => {
        // erd.listenTo(document.getElementById("lefttupu"), function (element) {
        //   var width = element.offsetWidth;
        //   var height = element.offsetHeight;
        //   // this.nowHeight=height
        //   that.$nextTick(function () {
        // //    console.log("Size: " + width + "x" + height);
        //     if (this.$store.state.timeRadio == 1) {
        //       if (this.$store.state.showPlanttree) {
        //         this.myWidth = '0px';
        //         this.showMenu = false;
        //         this.$store.state.showPlanttree = false;
        //       } else {
        //         this.myWidth = '230px';
        //       }
        //     }
        //     this.nowWidth = width;
        //     // this.nowHeight= height.toString()+'px'
        //     //  console.log('裂开了',this.nowWidth)
        //   });
        // });
        const resizeObeserver1 = new ResizeObserver(entries => {
          for (let entry of entries) {
            const width = entry.contentRect.width;
            this.$nextTick(() => {
              if (this.$store.state.timeRadio == 1) {
                if (this.$store.state.showPlanttree) {
                  this.myWidth = '0px';
                  this.showMenu = false;
                  this.$store.state.showPlanttree = false;
                } else {
                  this.myWidth = '230px';
                }
              }
              this.nowWidth = width;
            })
          }
        });
        try {
          resizeObeserver1.observe(document.getElementById("lefttupu"))
        } catch (error) {
          console.log(error)
        }

        plantHeight.listenTo(document.getElementById("leftAside"), function (element) {
          var plant_height = element.offsetHeight;
          if (document.getElementById("UnitOverviewMap")) {
            document.getElementById("UnitOverviewMap").style.height = plant_height.toString() + 'px';
          }
        });
      });
    }

    this.$refs.ui.style.setProperty('--bgcolor', this.$store.state.bgcolor);
    this.$refs.ui.style.setProperty('--conbgcolor', this.$store.state.conbgcolor);
    this.$refs.ui.style.setProperty('--leftconbgcolor', this.$store.state.leftconbgcolor);
    this.$refs.ui.style.setProperty('--buttoncolor', this.$store.state.buttoncolor);
    this.$refs.ui.style.setProperty('--treeinputbgcolor', this.$store.state.treeinputbgcolor);
    this.$refs.ui.style.setProperty('--labelcolor', this.$store.state.labelcolor);
    this.$refs.ui.style.setProperty('--scrollbarbgcolor', this.$store.state.scrollbarbgcolor);
    this.$refs.ui.style.setProperty('--scrollbarthumbbgcolor', this.$store.state.scrollbarthumbbgcolor);
    this.$refs.ui.style.setProperty('--activetextcolor', this.$store.state.activetextcolor);
  },
  beforeCreate() {
    let intervalid = setTimeout(() => {
      console.table({
        version: '2.5.2',
        date: window.versionTime,
        NODE_ENV: process.env.NODE_ENV,
      })
    }, 2000);
    console.table({
      version: '2.5.2',
      date: "2026-05-15 18:00:00",
      NODE_ENV: process.env.NODE_ENV,
    })

    // console.log('version: 1.6.4 date: 2022.9.23');
  },

  async created() {
    // exportToExcel() //将中英文对照词组导出
    this.saveUrlParams()//保存url中参数，初始化主题、语言
    //获取文件中所有轴承信息
    try {
      let url = process.env.NODE_ENV == 'production' ? '../../bs_ui/static/bearings.csv' : '../../static/bearings.csv'
      this.$axios.get(url).then(res => {
        const parsedData = parse(res.data, {header: true, skipEmptyLines: true});
        for (let i in parsedData.data) {
          this.$store.state.bearingInfoList[parsedData.data[i].BEARING_ID] = parsedData.data[i]
        }
      });
    } catch (error) {
      console.error('Error fetching data: ', error);
    }

    //暂时先放这，后续单独创建文件封装
    let axiosInstance = this.$axios.create({
      baseURL: '',
      timeout: 15000,
    })
    axiosInstance.interceptors.request.use(config => {
      // 设置动态请求头
      config.headers['Request_id'] = this.generateUUID()
      config.headers['X_timestamp'] = Date.now() + this.$store.state.serverTimeOffset
      return config
    }, error => {
      return Promise.reject(error)
    })
    this.$store.state.axiosInstance = this.$axios.create({
      baseURL: config.backEndBaseUrl,
      timeout: 100000,
    })
    this.$store.state.axiosInstance.interceptors.request.use(config => {
      // 设置动态请求头
      config.headers['Request_id'] = this.generateUUID()
      config.headers['X_timestamp'] = Date.now() + this.$store.state.serverTimeOffset
      return config
    }, error => {
      return Promise.reject(error)
    })
    this.$store.state.axiosInstanceBhapi = this.$axios.create({
      baseURL: '/bhapi',
      timeout: 100000,
    })
    this.$store.state.axiosInstanceBhapi.interceptors.request.use(config => {
      // 设置动态请求头
      config.headers['Request_id'] = this.generateUUID()
      config.headers['X_timestamp'] = Date.now() + this.$store.state.serverTimeOffset
      return config
    }, error => {
      return Promise.reject(error)
    })

    let tempToken = localStorage.getItem('token');
    if (tempToken != undefined) {
      this.$store.state.token = tempToken.startsWith('Bearer ') ? tempToken : 'Bearer ' + tempToken
      this.$axios.defaults.headers.common['Authorization'] = this.$store.state.token
      axiosInstance.defaults.headers.common['Authorization'] = this.$store.state.token
      this.$store.state.axiosInstance.defaults.headers.common['Authorization'] = this.$store.state.token
      this.$store.state.axiosInstanceBhapi.defaults.headers.common['Authorization'] = this.$store.state.token
    } else {
      this.$store.state.axiosInstance.defaults.headers.common['Authorization'] = 'Bearer-local'
      this.$store.state.axiosInstanceBhapi.defaults.headers.common['Authorization'] = 'Bearer eyJhbGciOiJFUzI1NiJ9.eyJpc3MiOiJiaHh6Lm5ldCIsImV4cCI6MTc1MTAzMDcyOSwic3ViIjoiQkhBUEkiLCJhdWQiOiJjZW50ZXIiLCJkYXRhS2V5IjoiIiwiaWF0IjoxNzUwMjEzMzIzfQ.DHeTb4FJu7K5rEI38rUIBm4Q8su3UjXq_DIBH35G1zXzk1Xd4PMaQCS1jT2la9_1d6ciW40sl-6Fy9t4i3sepw'
    }
    if (config.menu.interface) { // 获取平台接口配置
      this.$axios.get('/properties/findByApp', {
        params: {
          application: 'bs',
        }
      }).then(res => {
        if (res.data.code == 200) {
          let mydata = res.data.data;
          for (let item in mydata) {
            let tmp = mydata[item].key;
            if (tmp == 'DefaultMax500HzInFrequencyGraph') {
              // this.tmpmenu['DefaultMax500HzInFrequencyGraph'] = mydata[item];
              this.$store.state.DefaultMax500HzInFrequencyGraph = mydata[item].value.show;
            }
            if (tmp == 'OfflineOverviewIP') {
              this.tmpmenu[tmp] = mydata[item].value;
              this.$store.state.ProcessOverviewIP = mydata[item].value;
            } else if (tmp == 'ProcessOverviewIP') {
              this.tmpmenu[tmp] = mydata[item].value;
              this.$store.state.ProcessOverviewIP = mydata[item].value;
            }
            // else if (tmp == 'OverviewDisplayMode') {
            //   this.$store.state.OverviewDisplayMode = Math.round(Number(mydata[item].value));
            // } else if (tmp == 'RoutineAnalysis' || tmp == 'OfflineAnalysis') {
            //   let myjson = mydata[item].value;
            //   this.tmpmenu['OfflineAnalysis'].show = myjson.show;
            //   this.tmpmenu['OfflineAnalysis'].name = myjson.name;
            // } else if (tmp == 'threeDimensionalOverviewIP') {
            //   this.$store.state.threeDimensionalOverviewIP = mydata[item].value;
            // }
            else if (tmp == 'showProcessOverview') {
              this.$store.state.showProcessOverview = mydata[item].value;
            } else if (tmp == 'realTimeTrendUpdateInterval') {
              this.$store.state.realTimeTrendUpdateInterval = mydata[item].value * 1000;
            } else if (tmp == 'BSDeviceTreeUpdateInterval') {
              this.$store.state.BSDeviceTreeUpdateInterval = mydata[item].value * 1000;
            } else {
              let myjson = mydata[item].value;
              try {
                if (myjson && myjson.name && this.tmpmenu[tmp].name) {
                  this.tmpmenu[tmp].name = myjson.name;
                  this.tmpmenu[tmp].show = myjson.show;
                }
              } catch (e) {
                console.log(e);
              }
            }
          }
        } else {
          let myInterval = setInterval(() => {
            this.$axios.get('/properties/findByApp', {
              params: {
                application: 'bs',
              }
            }).then(res => {
              if (res.data.code == 200) {
                clearInterval(myInterval);
                let mydata = res.data.data;
                for (let item in mydata) {
                  let tmp = mydata[item].key;
                  let myjson = mydata[item].value;
                  if (myjson) {
                    this.tmpmenu[tmp].name = myjson.name;
                    this.tmpmenu[tmp].show = myjson.show;
                  }
                }
              }

            })
          }, 3000)
        }
      })
      //调用平台接口，获取报警等级颜色
      axiosInstance.get('/center6/login/' + this.$store.state.username + '/webInit/').then(res => {
        if (res.data.code == 200) {
          this.$store.state.zhengchang = res.data.data.alarmColorInfo['0']
          this.$store.state.level1 = res.data.data.alarmColorInfo['1']
          this.$store.state.level2 = res.data.data.alarmColorInfo['2']
          this.$store.state.level3 = res.data.data.alarmColorInfo['3']
          this.$store.state.hLevel = res.data.data.alarmColorInfo['4']
          this.$store.state.hhLevel = res.data.data.alarmColorInfo['5']
          this.$store.state.tingji = res.data.data.alarmColorInfo['-1']
          this.$store.state.duangwang = res.data.data.alarmColorInfo['-2']
          this.$refs.plant.setAlarmColor()
        }
        // else if(res.data.code != 800301){
        //   let tmpInterval = setInterval(() => {
        //     axiosInstance.get('/center6/login/'+this.$store.state.username+'/webInit/').then(res => {
        //       if(res.data.code == 200) {
        //         clearInterval(tmpInterval);
        //         this.$store.state.zhengchang = res.data.data.alarmColorInfo['0']
        //         this.$store.state.level1 = res.data.data.alarmColorInfo['1']
        //         this.$store.state.level2 = res.data.data.alarmColorInfo['2']
        //         this.$store.state.level3 = res.data.data.alarmColorInfo['3']
        //         this.$store.state.hLevel = res.data.data.alarmColorInfo['4']
        //         this.$store.state.hhLevel = res.data.data.alarmColorInfo['5']
        //         this.$store.state.tingji = res.data.data.alarmColorInfo['-1']
        //         this.$store.state.duangwang = res.data.data.alarmColorInfo['-2']
        //         this.$refs.plant.setAlarmColor()
        //       }
        //     })
        //   }, 3000)
        // }
      }).catch(e => {
        console.log(e)
      })
    }
  },
  computed: {
    ...mapState({
      backgroundcolor: 'backgroundcolor',
      activetextcolor: 'activetextcolor',
      textcolor: 'textcolor',
      dataSource: 'dataSource'
    }),

    showLanguage() {
      return process.env.NODE_ENV === 'development' && config.showLanguage;  // 平台不显示切换语言，平台通过url切换
    },

    showTopic() {
      return process.env.NODE_ENV === 'development' && config.showTopic; // 平台不显示切换主题，平台通过url切换
    },

    config() {
      return config
    },

    menu() {
      if (config.menu.interface) {
        // console.log('使用接口', this.tmpmenu);
        this.tmpmenu.DieselMonitorSystem.show = false
        this.tmpmenu.gasTurbineGraph.show = false
        this.tmpmenu.SpecialManualOfPump1.show = false
        return this.tmpmenu;
      } else {
        // console.log('未使用接口');
        return config.menu;
      }

    },
    myRoute() {
      return this.$route.path;
    },
    fullUrl() {
      return this.$route.fullPath;
    },
    etype() {
      return this.$store.state.etype;
    },
    nowequid() {
      return this.$store.state.equid.toString();
    },
    nowequname() {
      return this.$store.state.equName.toString();
    },
    showDiesel() {
      return ([10].indexOf(this.etype) === -1 || this.dataSource != 1);
    },
    showReciprocat() {
      return ([6].indexOf(this.etype) === -1 || this.dataSource != 1);
      // return this.etype !== 6;  //wangfu
    },
    showManual() {
      return ([7].indexOf(this.etype) === -1 || this.dataSource != 1);
      // return this.etype !== 7;   //机泵
    },
    showGas() {
      // return this.etype !== 2; //燃气轮机
      // return false;
      return ([2].indexOf(this.etype) === -1 || this.dataSource != 1);
    },
    showEscalator() {
      // return this.etype !== 7;   //扶梯
      return ([7].indexOf(this.etype) === -1);
    },
    showHeatingFurnace() {
      return ([8, 9].indexOf(this.etype) == -1); //加热炉
    },
    showRotating() {
      return ([0, 1, 3, 4].indexOf(this.etype) === -1 || this.dataSource != 1);  //旋转
    },
    showWireless() {
      // return this.etype !== 7;   //无线机泵
      return ([1007].indexOf(this.etype) === -1 || this.dataSource != 4);
    },
    showToC() {
      return (this.dataSource != 8);
    },
    showOffline() {
      // 离线
      return (this.dataSource !== 0);
    },
    activeIndex() {
      //alert(this.$route.path.replace('/', ''));
      // console.log(this.$route.path);
      return this.$route.path;
    },
    topiccolor() {
      return this.$store.state.topiccolor;
    },
    language() {
      return this.$store.state.language
    },
    upsHeight() {
      return window.innerHeight / 2 - 80 + 'px'
    },
    bearingInfoHeight() {
      return window.innerHeight / 2 - 200 + 'px'
    },
    BenchmarkInformationHeight() {
      return window.innerHeight / 2 - 350 + 'px'
    },
    showBearingDialog() {
      return this.$store.state.showBearingDialogFlag
    },
    dialogTextColor() {
      let textColor = this.$store.state.textcolor;
      switch(this.$store.state.topiccolor) {
        case 'high-ash':
        case 'dark':
        case 'gray':
        case 'ash':
          textColor = '#b7bac0';
          break;
        case 'quiet-blue':
        case 'blue':
          textColor = '#b7bac0';
          break;
        case 'simple-white':
        case 'white':
          textColor = '#303133';
          break;
        default:
          textColor = '#303133';
      }
      return textColor;
    },
    dialogBorderColor() {
      let borderColor = this.$store.state.selectbordercolor;
      switch(this.$store.state.topiccolor) {
        case 'high-ash':
        case 'dark':
          borderColor = '#66686c';
          break;
        case 'quiet-blue':
        case 'blue':
          borderColor = '#4a5a7a';
          break;
        default:
          borderColor = '#22233166';
      }
      return borderColor;
    }
  },

  watch: {
    topiccolor(val) {
      this.$refs.ui.style.setProperty('--bgcolor', this.$store.state.bgcolor);
      this.$refs.ui.style.setProperty('--conbgcolor', this.$store.state.conbgcolor);
      this.$refs.ui.style.setProperty('--leftconbgcolor', this.$store.state.leftconbgcolor);
      this.$refs.ui.style.setProperty('--buttoncolor', this.$store.state.buttoncolor);
      this.$refs.ui.style.setProperty('--treeinputbgcolor', this.$store.state.treeinputbgcolor);
      this.$refs.ui.style.setProperty('--labelcolor', this.$store.state.labelcolor);
      this.$refs.ui.style.setProperty('--scrollbarbgcolor', this.$store.state.scrollbarbgcolor);
      this.$refs.ui.style.setProperty('--scrollbarthumbbgcolor', this.$store.state.scrollbarthumbbgcolor);
      this.$refs.ui.style.setProperty('--activetextcolor', this.$store.state.activetextcolor);
      // 更新基准数据信息弹窗主题
      this.setEventDialogTheme();
    },
    myRoute(val) {
      if (val.indexOf('StatisticOfAlarm') != -1) {
        console.log('报警统计', val);
        this.myWidth = '0px';
        console.log(this.myWidth);
        // that.changeflag();
      } else {
        this.myWidth = '230px';
      }
      // console.log(val);
    },
    fullUrl() {          // url改变
      console.log(this.fullUrl);
      this.closePromptBox();

    },
    showBearingDialog() {
      this.BEARING_ID = this.$store.state.BEARING_ID//轴承编号
      this.BEARING_REV = this.$store.state.BEARING_REV//转速
      this.innerValue = this.$store.state.innerValue//内圈
      this.rollingValue = this.$store.state.rollingValue//滚动体
      this.outerValue = this.$store.state.outerValue//外圈
      this.cageValue = this.$store.state.cageValue//保持架
      this.fi = this.$store.state.fi//内圈旋转频率
      this.fo = this.$store.state.fo//外圈故障特征频率
      this.fe = this.$store.state.fe//滚动体故障特征频率
      this.fc = this.$store.state.fc//保持架故障特征频率
    }
  },


  methods: {
    generateUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = Math.random() * 16 | 0
        const v = c === 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    },
    onInputNumber(value) {
      this.BEARING_REV = value.replace(/\D/g, ''); // 只保留数字
    },
    saveUrlParams() {
      //若url中存在下方变量，则更新
      this.$store.state.equid = this.$route.query.equipmentUuid ? this.$route.query.equipmentUuid : this.$store.state.equid
      //保存到sessionStorage，页面刷新在sessionStorage获取
      if (this.$route.query.uid) {
        this.$store.state.uid = decodeURIComponent(this.$route.query.uid)
        sessionStorage.setItem('uid', this.$store.state.uid)
      } else {
        this.$store.state.uid = sessionStorage.getItem('uid') ? sessionStorage.getItem('uid') : this.$store.state.uid
      }
      if (this.$route.query.username) {
        this.$store.state.username = decodeURIComponent(this.$route.query.username)
        sessionStorage.setItem('username', this.$store.state.username)
      } else {
        this.$store.state.username = sessionStorage.getItem('username') ? sessionStorage.getItem('username') : null
      }
      if (this.$route.query.pointId) {
        this.$store.state.pointId = decodeURIComponent(this.$route.query.pointId)
        sessionStorage.setItem('pointId', this.$store.state.pointId)
      } else {
        this.$store.state.pointId = sessionStorage.getItem('pointId') ? sessionStorage.getItem('pointId') : ''
      }
      this.$store.state.globalPointId = this.$store.state.pointId
      this.$store.state.alarmStartTime = this.$route.query.alarmStartTime ? decodeURIComponent(this.$route.query.alarmStartTime) : this.$store.state.alarmStartTime
      this.$store.state.alarmEndTime = this.$route.query.alarmEndTime ? decodeURIComponent(this.$route.query.alarmEndTime) : this.$store.state.alarmEndTime
      //主题初始化
      this.$store.state.topiccolor = this.$route.query.topic ? this.$route.query.topic : config.topic
      this.changeTopic(this.$store.state.topiccolor);
      //语言初始化
      this.$store.state.language = this.$route.query.language ? this.$route.query.language : config.language
      if (this.language == 'zh') {
        this.translateLan('zh')
      } else if (this.language == 'en') {
        this.translateLan('en')
      } else if (this.language == 'ru') {
        this.translateLan('ru')
      }
    },
    setnowname(newname) {
      //     this.$refs.unitnfo.setequname(newname);
    },
    // async getToken() {
    //   // 获取token
    //   this.$axios.defaults.baseURL = process.env.NODE_ENV == 'production' ? '': '/inter1';
    //
    //   this.$axios.defaults.headers.common["Authorization"] = '123';
    //   delete this.$axios.defaults.headers.common["Authorization"];
    //
    //   const res = await this.$axios.post('/auth/oauth/token?password=Buct@20230418&grant_type=password&client_secret=111&client_id=center6&username=buct')
    //   this.$axios.defaults.baseURL = '/bs'
    //
    //   let tmptoken = res.data.data.access_token
    //   this.$store.state.token = tmptoken
    //   // console.log('我的令牌', tmptoken);
    //   this.$axios.defaults.headers.common['Authorization'] = 'Bearer ' + tmptoken;
    // },

    changeTopic(topic) { // 改变主题颜色
      if (topic == 'white' || topic == 'simple-white') {
        this.$store.state.backgroundcolor = '#fdfdfd';
        this.$store.state.bgcolor = '#fdfdfd';
        this.$store.state.textcolor = '#000000';
        this.$store.state.activetextcolor = '#1677FF';
        this.$store.state.buttoncolor = '#1677FF';
        this.$store.state.buttontextcolor = '#ffffff';
        this.$store.state.conbgcolor = '#F1F6FE';
        this.$store.state.leftconbgcolor = '#fdfdfd'
        this.$store.state.elbgcolor = '#fdfdfd';
        this.$store.state.topiccolor = 'simple-white';
        this.$store.state.inputbgcolor = '#fdfdfd';
        this.$store.state.pointcolor = '#FAFAFA';
        this.$store.state.eltreecolor = '#FAFAFA';
        this.$store.state.eltreebordercolor = '#C1C1C1';
        this.$store.state.checkedcolor = '#1677FF'
        this.$store.state.selectbordercolor = '#000000CC'

        this.$store.state.treeinputbgcolor = 'white';
        this.$store.state.toolboxcolor = '#7A7AA4';
        this.$store.state.labelcolor = '#696B6F';
        this.$store.state.linecolor = 'rgba(0, 0, 0, 0.3)';
        this.$store.state.threedcolor = '#add8e6';
        this.$store.state.markcolor = '#FF0B00';
        this.$store.state.markbordercolor = '#ffffff';
        this.$store.state.toolboxtextcolor = '#1890FF';
        this.$store.state.tablecolor = '#ffffff';
        this.$store.state.scrollbarbgcolor = 'rgba(193,193,193,0.2)';
        this.$store.state.scrollbarthumbbgcolor = 'rgba(193,193,193,1)';
        this.$store.state.primarySecondaryColor = ['#FF0000', '#FF00FF'];
        this.$store.state.defaultButtonColor = '#0052CC';
        this.$store.state.colorMap = [
          "#0000FF",
          "#CC99FF",
          "#FF9900",
          "#FFCC00",
          "#FFCCCC",
          "#CCCC66",
          "#FFCC99",
          "#FF99FF",
          "#423F36",
          "#0097A7",
          "#8E24AA",
          "#4C144F",
          "#111011",
          "#C5E1A5",
          "#EB984E",
          "#206C8D",
          "#E6EE9C",
          "#359186",
          "#FFE082",
          "#FF99FF",
          "#232835",
          "#703838",
          "#BCAAA4",
          "#FFCC80",
        ];
        this.setEventDialogTheme();
        return
        //旧版
        this.$store.state.backgroundcolor = 'white';
        this.$store.state.textcolor = '#666666';
        this.$store.state.activetextcolor = '#1890FF';
        this.$store.state.bgcolor = 'white';
        this.$store.state.conbgcolor = '#F1F4FB';
        this.$store.state.leftconbgcolor = 'white';
        this.$store.state.elbgcolor = 'gray';
        this.$store.state.pointcolor = 'white';
        this.$store.state.topiccolor = 'white';
        this.$store.state.inputbgcolor = 'white';
        this.$store.state.buttoncolor = '#A0A2D5';
        this.$store.state.eltreecolor = '#FAFAFA';
        this.$store.state.treeinputbgcolor = 'white';
        this.$store.state.toolboxcolor = '#7A7AA4';
        this.$store.state.labelcolor = '#696B6F';
        this.$store.state.linecolor = 'rgba(0, 0, 0, 0.3)';
        this.$store.state.threedcolor = '#add8e6';
        this.$store.state.markcolor = '#FF0B00';
        this.$store.state.markbordercolor = '#ffffff';
        this.$store.state.toolboxtextcolor = '#1890FF';
        this.$store.state.tablecolor = '#ffffff';
        this.$store.state.scrollbarbgcolor = 'white';
        this.$store.state.scrollbarthumbbgcolor = '#c1c1c1';
        this.$store.state.colorMap = [
          "#0000FF",
          "#CC99FF",
          "#FF9900",
          "#FFCC00",
          "#FFCCCC",
          "#CCCC66",
          "#FFCC99",
          "#FF99FF",
          "#423F36",
          "#0097A7",
          "#8E24AA",
          "#4C144F",
          "#111011",
          "#C5E1A5",
          "#EB984E",
          "#206C8D",
          "#E6EE9C",
          "#359186",
          "#FFE082",
          "#FF99FF",
          "#232835",
          "#703838",
          "#BCAAA4",
          "#FFCC80",
        ];
      } else if (topic == 'quiet-blue') {
        this.$store.state.backgroundcolor = '#011e5a';
        this.$store.state.bgcolor = '#011e5a';
        this.$store.state.textcolor = '#ffffff';
        this.$store.state.activetextcolor = '#0FDDDD';
        this.$store.state.buttoncolor = '#0FDDDD';
        this.$store.state.buttontextcolor = '#ffffff';
        this.$store.state.conbgcolor = '#040440';
        this.$store.state.leftconbgcolor = '#011e5a'
        this.$store.state.elbgcolor = '#011e5a';
        this.$store.state.topiccolor = 'quiet-blue';
        this.$store.state.inputbgcolor = '#011e5a';
        this.$store.state.pointcolor = '#021c54';
        this.$store.state.eltreecolor = '#021c54';
        this.$store.state.eltreebordercolor = 'rgba(0, 0, 0, 0.85)'
        this.$store.state.checkedcolor = '#0FDDDD'
        this.$store.state.selectbordercolor = '#FFFFFFCC'

        this.$store.state.treeinputbgcolor = '#ffffff';
        this.$store.state.toolboxcolor = '#ffffff';
        this.$store.state.labelcolor = '#696B6F';
        this.$store.state.linecolor = 'rgba(255, 255, 255, 0.3)';
        this.$store.state.threedcolor = '#007878';
        this.$store.state.markcolor = '#ffffff';
        this.$store.state.markbordercolor = '#FF0B00';
        this.$store.state.toolboxtextcolor = '#439cff';
        this.$store.state.tablecolor = '#091A42';
        this.$store.state.scrollbarbgcolor = 'rgba(193,193,193,0.2)';
        this.$store.state.scrollbarthumbbgcolor = 'rgba(193,193,193,1)';
        this.$store.state.defaultButtonColor = '#46E9FF';
        this.$store.state.colorMap = [
          "#00FF00",
          "#CC99FF",
          "#FF9900",
          "#FFCC00",
          "#FFCCCC",
          "#CCCC66",
          "#FFCC99",
          "#FF99FF",
          "#FF00FF",
          "#006000",
          "#703838",
          "#C5E1A5",
          "#E6EE9C",
          "#FFF59D",
          "#FFE082",
          "#FFCC80",
          "#FFAB91",
          "#BCAAA4",
          "#EEEEEE",
          "#B0BEC5",
          "#689F38",
          "#0097A7",
          "#8E24AA",
          "#E91E63"
        ];
        this.$store.state.primarySecondaryColor = ['#FF0000', '#FF00FF']
        this.setEventDialogTheme();
        return
        //旧版
        this.$store.state.backgroundcolor = '#2c3242';
        this.$store.state.textcolor = 'white';
        this.$store.state.activetextcolor = '#359186';
        this.$store.state.bgcolor = '#2c3242';
        this.$store.state.conbgcolor = '#232835';
        this.$store.state.leftconbgcolor = '#303749';
        this.$store.state.elbgcolor = '#303749';
        this.$store.state.pointcolor = '#3C455B';
        this.$store.state.topiccolor = 'blue';
        this.$store.state.inputbgcolor = '#303749';
        this.$store.state.buttoncolor = '#359186';
        this.$store.state.eltreecolor = '#3C455B';
        this.$store.state.treeinputbgcolor = '#ffffff';
        this.$store.state.toolboxcolor = '#ffffff';
        this.$store.state.labelcolor = '#696B6F';
        this.$store.state.linecolor = 'rgba(255, 255, 255, 0.3)';
        this.$store.state.threedcolor = '#007878';
        this.$store.state.markcolor = '#ffffff';
        this.$store.state.markbordercolor = '#FF0B00';
        this.$store.state.toolboxtextcolor = '#D1EADF';
        this.$store.state.tablecolor = '#091A42';
        this.$store.state.scrollbarbgcolor = '#061d74';
        this.$store.state.scrollbarthumbbgcolor = '#646563';
        this.$store.state.checkedcolor = '#1677FF'
        this.$store.state.colorMap = [
          "#00FF00",
          "#CC99FF",
          "#FF9900",
          "#FFCC00",
          "#FFCCCC",
          "#CCCC66",
          "#FFCC99",
          "#FF99FF",
          "#FF00FF",
          "#006000",
          "#703838",
          "#C5E1A5",
          "#E6EE9C",
          "#FFF59D",
          "#FFE082",
          "#FFCC80",
          "#FFAB91",
          "#BCAAA4",
          "#EEEEEE",
          "#B0BEC5",
          "#689F38",
          "#0097A7",
          "#8E24AA",
          "#E91E63"
        ];
      } else if (topic == 'gray') {
        this.$store.state.backgroundcolor = '#403D4E';
        this.$store.state.textcolor = 'white';
        this.$store.state.activetextcolor = '#439cff';
        this.$store.state.bgcolor = '#403D4E';
        this.$store.state.conbgcolor = '#2B2935';
        this.$store.state.leftconbgcolor = '#403D4E';
        this.$store.state.elbgcolor = 'gray';
        this.$store.state.pointcolor = '#403D4E';
        this.$store.state.topiccolor = 'gray';
        this.$store.state.inputbgcolor = '#2B2935';
        this.$store.state.buttoncolor = '#1677FF';
        this.$store.state.eltreecolor = '#2B2935';
        this.$store.state.treeinputbgcolor = '#05050D';
        this.$store.state.toolboxcolor = '#ffffff';
        this.$store.state.labelcolor = '#ffffff';
        this.$store.state.linecolor = 'rgba(255, 255, 255, 0.3)';
        this.$store.state.threedcolor = '#007878';
        this.$store.state.markcolor = '#ffffff';
        this.$store.state.markbordercolor = '#FF0B00';
        this.$store.state.toolboxtextcolor = '#439cff';
        this.$store.state.tablecolor = '#091A42';
        this.$store.state.scrollbarbgcolor = '#061d74';
        this.$store.state.scrollbarthumbbgcolor = '#646563';
        this.$store.state.checkedcolor = '#1677FF'
        this.$store.state.selectbordercolor = '#439cff'
        this.$store.state.colorMap = [
          "#00FF00",
          "#CC99FF",
          "#FF9900",
          "#FFCC00",
          "#FFCCCC",
          "#CCCC66",
          "#FFCC99",
          "#FF99FF",
          "#FF00FF",
          "#006000",
          "#703838",
          "#C5E1A5",
          "#E6EE9C",
          "#FFF59D",
          "#FFE082",
          "#FFCC80",
          "#FFAB91",
          "#BCAAA4",
          "#EEEEEE",
          "#B0BEC5",
          "#689F38",
          "#0097A7",
          "#8E24AA",
          "#E91E63"
        ];
        this.$store.state.primarySecondaryColor = ['#FF0000', '#FF00FF']
      } else if (topic == 'high-ash') {
        this.$store.state.backgroundcolor = '#222331';
        this.$store.state.bgcolor = '#222331';
        this.$store.state.textcolor = 'white';
        this.$store.state.activetextcolor = '#1677FF';
        this.$store.state.buttoncolor = '#1677FF';
        this.$store.state.buttontextcolor = '#ffffff';
        this.$store.state.conbgcolor = '#0D0F1F';
        this.$store.state.leftconbgcolor = '#222331'
        this.$store.state.elbgcolor = '#222331';
        this.$store.state.topiccolor = 'high-ash';
        this.$store.state.inputbgcolor = '#222331';
        this.$store.state.pointcolor = '#1D1E2C';
        this.$store.state.eltreecolor = '#1D1E2C';
        this.$store.state.eltreebordercolor = '#000';
        this.$store.state.checkedcolor = '#1677FF'
        this.$store.state.selectbordercolor = '#FFFFFFCC'

        this.$store.state.treeinputbgcolor = '#ffffff';
        this.$store.state.toolboxcolor = '#ffffff';
        this.$store.state.labelcolor = '#696B6F';
        this.$store.state.linecolor = 'rgba(255, 255, 255, 0.3)';
        this.$store.state.threedcolor = '#007878';
        this.$store.state.markcolor = '#ffffff';
        this.$store.state.markbordercolor = '#FF0B00';
        this.$store.state.toolboxtextcolor = '#D1EADF';
        this.$store.state.tablecolor = '#091A42';
        this.$store.state.scrollbarbgcolor = 'rgba(193,193,193,0.2)';
        this.$store.state.scrollbarthumbbgcolor = 'rgba(193,193,193,1)';
        this.$store.state.defaultButtonColor = '#1D8EFF';
        this.$store.state.colorMap = [
          "#00FF00",
          "#CC99FF",
          "#FF9900",
          "#FFCC00",
          "#FFCCCC",
          "#CCCC66",
          "#FFCC99",
          "#FF99FF",
          "#FF00FF",
          "#006000",
          "#703838",
          "#C5E1A5",
          "#E6EE9C",
          "#FFF59D",
          "#FFE082",
          "#FFCC80",
          "#FFAB91",
          "#BCAAA4",
          "#EEEEEE",
          "#B0BEC5",
          "#689F38",
          "#0097A7",
          "#8E24AA",
          "#E91E63"
        ];
        this.$store.state.primarySecondaryColor = ['#4CE7FF', '#FFFF00']
        this.setEventDialogTheme();
        return
        this.$store.state.backgroundcolor = '#1E2128';
        this.$store.state.textcolor = 'white';
        this.$store.state.activetextcolor = '#439cff';
        this.$store.state.bgcolor = '#1E2128';
        this.$store.state.conbgcolor = '#191A1F';
        this.$store.state.leftconbgcolor = '#1E2128';
        this.$store.state.elbgcolor = 'gray';
        this.$store.state.pointcolor = '#1E2128';
        this.$store.state.topiccolor = 'high-ash';
        this.$store.state.inputbgcolor = '#05050D';
        this.$store.state.buttoncolor = '#FFFFFF';
        this.$store.state.eltreecolor = '#191A1F';
        this.$store.state.treeinputbgcolor = '#05050D';
        this.$store.state.toolboxcolor = '#ffffff';
        this.$store.state.labelcolor = '#ffffff';
        this.$store.state.linecolor = 'rgba(255, 255, 255, 0.3)';
        this.$store.state.colorMap = [
          "#00FF00",
          "#CC99FF",
          "#FF9900",
          "#FFCC00",
          "#FFCCCC",
          "#CCCC66",
          "#FFCC99",
          "#FF99FF",
          "#FF00FF",
          "#006000",
          "#703838",
          "#C5E1A5",
          "#E6EE9C",
          "#FFF59D",
          "#FFE082",
          "#FFCC80",
          "#FFAB91",
          "#BCAAA4",
          "#EEEEEE",
          "#B0BEC5",
          "#689F38",
          "#0097A7",
          "#8E24AA",
          "#E91E63"
        ];
      } else if (topic == 'blue') {
        this.$store.state.backgroundcolor = '#2c3242';
        this.$store.state.textcolor = 'white';
        this.$store.state.activetextcolor = '#359186';
        this.$store.state.bgcolor = '#2c3242';
        this.$store.state.conbgcolor = '#232835';
        this.$store.state.leftconbgcolor = '#303749';
        this.$store.state.elbgcolor = '#303749';
        this.$store.state.pointcolor = '#3C455B';
        this.$store.state.topiccolor = 'blue';
        this.$store.state.inputbgcolor = '#303749';
        this.$store.state.buttoncolor = '#359186';
        this.$store.state.eltreecolor = '#3C455B';

        this.$store.state.treeinputbgcolor = '#ffffff';
        this.$store.state.toolboxcolor = '#ffffff';
        this.$store.state.labelcolor = '#696B6F';
        this.$store.state.linecolor = 'rgba(255, 255, 255, 0.3)';
        this.$store.state.threedcolor = '#007878';
        this.$store.state.markcolor = '#ffffff';
        this.$store.state.markbordercolor = '#FF0B00';
        this.$store.state.toolboxtextcolor = '#D1EADF';
        this.$store.state.tablecolor = '#091A42';
        this.$store.state.scrollbarbgcolor = '#061d74';
        this.$store.state.scrollbarthumbbgcolor = '#646563';
        this.$store.state.checkedcolor = '#1677FF'
        this.$store.state.colorMap = [
          "#00FF00",
          "#CC99FF",
          "#FF9900",
          "#FFCC00",
          "#FFCCCC",
          "#CCCC66",
          "#FFCC99",
          "#FF99FF",
          "#FF00FF",
          "#006000",
          "#703838",
          "#C5E1A5",
          "#E6EE9C",
          "#FFF59D",
          "#FFE082",
          "#FFCC80",
          "#FFAB91",
          "#BCAAA4",
          "#EEEEEE",
          "#B0BEC5",
          "#689F38",
          "#0097A7",
          "#8E24AA",
          "#E91E63"
        ];
        this.$store.state.primarySecondaryColor = ['#FF0000', '#FF00FF']

        this.$store.state.buttontextcolor = '#ffffff';
        this.$store.state.eltreebordercolor = 'rgba(0, 0, 0, 0.85)'
        this.$store.state.checkedcolor = '#0FDDDD'
        this.$store.state.selectbordercolor = '#FFFFFFCC'
      } else if (topic == 'ash') {
        this.$store.state.backgroundcolor = '#403D4E';
        this.$store.state.textcolor = 'white';
        this.$store.state.activetextcolor = '#439cff';
        this.$store.state.bgcolor = '#403D4E';
        this.$store.state.conbgcolor = '#2B2935';
        this.$store.state.leftconbgcolor = '#403D4E';
        this.$store.state.elbgcolor = 'gray';
        this.$store.state.pointcolor = '#403D4E';
        this.$store.state.topiccolor = 'ash';
        this.$store.state.inputbgcolor = '#2B2935';
        this.$store.state.buttoncolor = '#1677FF';
        this.$store.state.eltreecolor = '#2B2935';
        this.$store.state.treeinputbgcolor = '#05050D';
        this.$store.state.toolboxcolor = '#ffffff';
        this.$store.state.labelcolor = '#ffffff';
        this.$store.state.linecolor = 'rgba(255, 255, 255, 0.3)';
        this.$store.state.threedcolor = '#007878';
        this.$store.state.markcolor = '#ffffff';
        this.$store.state.markbordercolor = '#FF0B00';
        this.$store.state.toolboxtextcolor = '#439cff';
        this.$store.state.tablecolor = '#091A42';
        this.$store.state.scrollbarbgcolor = '#061d74';
        this.$store.state.scrollbarthumbbgcolor = '#646563';
        this.$store.state.colorMap = [
          "#00FF00",
          "#CC99FF",
          "#FF9900",
          "#FFCC00",
          "#FFCCCC",
          "#CCCC66",
          "#FFCC99",
          "#FF99FF",
          "#FF00FF",
          "#006000",
          "#703838",
          "#C5E1A5",
          "#E6EE9C",
          "#FFF59D",
          "#FFE082",
          "#FFCC80",
          "#FFAB91",
          "#BCAAA4",
          "#EEEEEE",
          "#B0BEC5",
          "#689F38",
          "#0097A7",
          "#8E24AA",
          "#E91E63"
        ];
        this.$store.state.primarySecondaryColor = ['#FF0000', '#FF00FF']

        this.$store.state.buttontextcolor = '#ffffff';
        this.$store.state.eltreebordercolor = '#000';
        this.$store.state.checkedcolor = '#1677FF'
        this.$store.state.selectbordercolor = '#FFFFFFCC'
      }
      // 调用主题更新方法，确保弹窗样式正确应用
      this.setEventDialogTheme();
    },

    closePromptBox() {
      // console.log('关闭弹窗');
      this.$refs.load.style.display = 'none';
      this.$refs.fail.style.display = 'none';
    },

    datafail() {
      console.log("数据获取失败");
      var that = this;
      this.$refs.load.style.display = 'none';
      this.$refs.fail.innerHTML = '<div class="failtext"><i class="el-icon-warning"></i>' + this.translateText('textMap.', '数据获取失败') + '</div>';
      this.$refs.fail.style.display = 'block';
      setTimeout(function () {
        that.$refs.fail.style.display = 'none';
      }, 3000);
      //  this.$refs.unitnfo.datafail();
    },
    /**
     *
     * @param type String类型的el-icon
     * @param text 显示文本
     */
    customTip(type, text) {
      console.log("hhhhhhhhhhhhhhhhhhhhhhhhhhhh");
      this.$refs.customTip.innerHTML = `<div class="customText"><i class="${type}"></i>${this.translateText('textMap.', text)}</div>`;
      this.$refs.customTip.style.display = 'block';
      setTimeout(() => {
        this.$refs.customTip.style.display = 'none';
      }, 3000);
    },
    tmpDataNull() {
      // console.log("无测点");
      // var that = this;
      // this.$refs.load.style.display = 'none';
      // this.$refs.fail.innerHTML = '<div class="failtext"><i class="el-icon-warning"></i>无测点</div>';
      // this.$refs.fail.style.display = 'block';
      // setTimeout(function () {
      //   that.$refs.fail.style.display = 'none';
      // },3000);
    },
    notEvent() {

      if (this.$route.path !== '/RotatingMachineryGraph/StartStopGraph') {
        return
      }


      var that = this;
      this.$refs.load.style.display = 'none';
      this.$refs.fail.innerHTML = '<div class="failtext"><i class="el-icon-warning"></i>' + this.translateText('textMap.', '请选择事件') + '</div>';
      this.$refs.fail.style.display = 'block';
      setTimeout(function () {
        that.$refs.fail.style.display = 'none';
      }, 3000);
    },
    datanull() {
      console.log("无数据");
      var that = this;
      this.$refs.load.style.display = 'none';
      this.$refs.fail.innerHTML = '<div class="failtext"><i class="el-icon-warning"></i>' + this.translateText('textMap.', '无数据') + '</div>';
      this.$refs.fail.style.display = 'block';
      setTimeout(function () {
        that.$refs.fail.style.display = 'none';
      }, 3000);
    },
    brushdatanull() {
      console.log("无数据");
      var that = this;
      this.$refs.load.style.display = 'none';
      this.$refs.fail.innerHTML = '<div class="failtext"><i class="el-icon-warning"></i>' + this.translateText('textMap.', '范围内无数据点') + '</div>';
      this.$refs.fail.style.display = 'block';
      setTimeout(function () {
        that.$refs.fail.style.display = 'none';
      }, 3000);
    },
    hideloading() {
      this.$refs.load.style.display = 'none';
    },
    dataloading() {
      console.log("数据加载中");
      let that = this;
      this.$refs.load.style.display = 'block';
      this.$refs.load.innerHTML = '<div class="loadingtext"><i class="el-icon-loading"></i>' + this.translateText('textMap.', '数据加载中') + '</div>';
      setTimeout(function () {
        that.$refs.load.style.display = 'none';
      }, 3000);
      // this.$refs.unitnfo.dataloading();
    },
    datasuccess() {
      console.log("数据获取成功");
      this.$refs.load.style.display = 'none';
      //this.$refs.unitnfo.datasuccess()
    },
    pointNull() {
      // var that = this;
      // console.log('请选择测点');
      // this.$refs.load.style.display = 'none';
      // this.$refs.fail.innerHTML = '<div class="failtext"><i class="el-icon-warning"></i>请选择测点</div>';
      // this.$refs.fail.style.display = 'block';
      // setTimeout(function () {
      //   that.$refs.fail.style.display = 'none';
      // },3000);
    },
    intervalError() {
      var that = this;
      console.log('参数区间错误');
      this.$refs.load.style.display = 'none';
      this.$refs.fail.innerHTML = '<div class="failtext"><i class="el-icon-warning"></i>参数区间错误</div>';
      this.$refs.fail.style.display = 'block';
      setTimeout(function () {
        that.$refs.fail.style.display = 'none';
      }, 3000);
    },
    notExitPoint() {
      var that = this;
      console.log('没有该测点');
      this.$refs.load.style.display = 'none';
      this.$refs.fail.innerHTML = '<div class="failtext"><i class="el-icon-warning"></i>没有该测点</div>';
      this.$refs.fail.style.display = 'block';
      setTimeout(function () {
        that.$refs.fail.style.display = 'none';
      }, 3000);
    },

    changeunitname(name) {
      //  this.$refs.unitnfo.changename(name);
    },

    ChangEquId() {
      this.equid = this.$store.state.equid;
    },
    async handleClick(event) {
      // if()
      // console.log(this.nowOpenedIndex.toString());
      document.querySelectorAll('input.graph-input').forEach((input) => {
        input.blur();
      })
      console.log('this.$refs.plant:', this.$refs.plant)
      if (this.$refs.plant.showDropdownFlag) {
        this.$refs.plant.showDropdownFlag = false
      }

      if (this.isOpened != true) {
        this.$refs.topMenu.close(this.nowOpenedIndex.toString());
        this.$refs.topMenu1.close(this.nowOpenedIndex.toString());
        this.$refs.topMenu2.close(this.nowOpenedIndex.toString());
      }
      this.isOpened = false;
      // else {
      //   if(event.target.className != 'el-submenu__title') {
      //     console.log('子菜单index', that.$refs.topMenu);
      //     that.$refs.topMenu.close(that.nowOpenedIndex);
      //     this.isOpened = false;
      //     // this.$refs.topMenu['default-active'] = this.activeIndex;
      //   }
      // }
      if (!event || event.type !== 'click') return

      const plantEl = this.$refs.plant && this.$refs.plant.$el
      if (plantEl && plantEl.contains(event.target)) return

      const equipmentUuid = this.$store.state.equid
      if (!equipmentUuid) return

      if (this._lastReportedEquipmentUuid === undefined) {
        try {
          this._lastReportedEquipmentUuid = localStorage.getItem('_lastEquipmentAccessUuid') || null
        } catch (e) {
          this._lastReportedEquipmentUuid = null
        }
      }

      if (
        this._lastReportedEquipmentUuid === equipmentUuid ||
        this._pendingEquipmentUuid === equipmentUuid
      ) return

      this._pendingEquipmentUuid = equipmentUuid

      try {
        await this.$axios.post('/user/equipment/access/record', {
          path: this.$route.path,
          equipmentUuid
        }, {
          baseURL: ''
        })
        this._lastReportedEquipmentUuid = equipmentUuid
        try {
          localStorage.setItem('_lastEquipmentAccessUuid', equipmentUuid)
        } catch (e) {
        }
      } catch (error) {
      } finally {
        if (this._pendingEquipmentUuid === equipmentUuid) {
          this._pendingEquipmentUuid = null
        }
      }
    },
    handleOpen(index) {
      this.nowOpenedIndex = index;
      this.isOpened = true;
    },

    // 切换语言
    translateLan(index) {
      this.$store.state.language = index;
      this.$router.push({
        query: {
          equipmentUuid: this.nowequid,
          topic: this.$store.state.topiccolor,
          language: this.$store.state.language
        }
      })
      this.$i18n.locale = index;
      document.title = this.translateText('textMap.', '分析诊断');
      if (index === 'zh') {
        locale.use(zh)
      } else if (index === 'en') {
        locale.use(en)
      } else if (index === 'ru') {
        locale.use(ru)
      }
    },
    updateRouter() {
      this.$nextTick(() => {
        if (this.$store.state.dataSource == 1) {
          if (this.$store.state.etype === 6) {
            if (this.menu.ReciprocatMachineryGraph.data['4-1'] == false) {
              this.handleSelect("ReciprocatMachineryGraph/ReciprocatVibrationMonitor");
            } else {
              if (this.$route.path.slice(1).indexOf('ReciprocatMachineryGraph') != -1) {
                this.handleSelect(this.$route.path.slice(1));
              } else {
                this.handleSelect("ReciprocatMachineryGraph/OverviewGraph1");
              }
            }
          } else if (this.$store.state.etype === 7) {
            if (this.$route.path.slice(1).indexOf('/') != -1 || this.$route.path == '/home') {
              if (!config.menu.SpecialManualOfPump.show && config.menu.EscalatorGraph.show) {
                this.handleSelect("EscalatorAlarmQueryGraph")
              } else {
                if (!config.menu.SpecialManualOfPump.data['1']) {
                  this.handleSelect('TrendAnalysis');
                } else {
                  this.handleSelect("UnitOverviewMap");
                }
              }
            } else {
              this.handleSelect(this.$route.path.slice(1));
            }
          } else if (this.$store.state.etype === 10) {
            if (this.menu.DieselMonitorSystem.data['5-1'] == false) {
              this.handleSelect("DieselMonitorSystem/VibrationMonitorGraph");
            } else {
              if (this.$route.path.slice(1).indexOf('DieselMonitorSystem') != -1) {
                this.handleSelect(this.$route.path.slice(1));
              } else {
                this.handleSelect("DieselMonitorSystem/OverviewGraph");
              }
            }


          } else if ([0, 1, 3, 4].indexOf(this.$store.state.etype) !== -1) {
            if (this.menu.RotatingMachineryGraph.data['6-15'] == false) {
              this.handleSelect("RotatingMachineryGraph/RotatingVibrationMonitor");
            } else {
              if (this.$route.path.slice(1).indexOf('RotatingMachineryGraph') != -1) {
                this.handleSelect(this.$route.path.slice(1));
              } else {
                if (!config.menu.RotatingMachineryGraph.data['6-15']) {
                  this.handleSelect('RotatingMachineryGraph/RotatingVibrationMonitor')
                } else {
                  this.handleSelect("RotatingMachineryGraph/RotatingOverviewGrap");
                }
              }
            }
          } else if (this.$store.state.etype == 2) {
            if (this.menu.gasTurbineGraph.data['6-15'] == false) {
              this.handleSelect("gasTurbineGraph/GasVibrationMonitor");
            } else {
              if (this.$route.path.slice(1).indexOf('gasTurbineGraph') != -1) {
                this.handleSelect(this.$route.path.slice(1));
              } else {
                this.handleSelect("gasTurbineGraph/GasOverviewGrap");
              }
            }
          } else if ([8, 9].indexOf(this.$store.state.etype) != -1) {
            if (this.$route.path.slice(1).indexOf('HeatingFurnaceGraph') != -1) {
              this.handleSelect(this.$route.path.slice(1));
            } else {
              this.handleSelect("HeatingFurnaceGraph/HeatingFurnaceUnitOverviewMap");
            }
          } else {
            this.$router.push({
              path: '/home',
              query: {
                equipmentUuid: this.nowequid,
                topic: this.$store.state.topiccolor,
                language: this.$store.state.language
              }
            })
          }
        } else if (this.$store.state.dataSource == 4) {
          if (this.$route.path.slice(1).indexOf('WirelessPumpGraph') != -1) {
            this.handleSelect(this.$route.path.slice(1));
          } else {
            this.handleSelect("WirelessPumpGraph/WirelessPumpUnitOverviewMap");
          }
        } else if (this.$store.state.dataSource == 8) {
          if (this.$route.path.slice(1).indexOf('WirelessToCMachineryGraph') != -1) {
            this.handleSelect(this.$route.path.slice(1));
          } else {
            this.handleSelect("WirelessToCMachineryGraph/ToCVibrationMonitor");
          }
        } else {
          if (this.$route.path.slice(1).indexOf('Offline') != -1) {
            this.handleSelect(this.$route.path.slice(1));
          } else {
            this.handleSelect("Offline/OLUnitOverviewMap");
          }
        }
      })
    },
    handleSelect(index, filePath) {
      index = filePath ? index : '/' + index
      this.$router.push({
        path: index,
        query: {equipmentUuid: this.nowequid, topic: this.$store.state.topiccolor, language: this.$store.state.language}
      })
      document.getElementById('lefttupu').style.position = 'relative'
      // //报警统计
      // if (index === 'StatisticOfAlarm') {
      //   this.nowpos = '/StatisticOfAlarm';
      //   this.$router.push({path: "/StatisticOfAlarm", query: this.$route.query});
      // }
      // //另一个报警统计
      // if (index === 'AnotherStatisticOfAlarm') {
      //   this.nowpos = '/AnotherStatisticOfAlarm';
      //   this.$router.push({path: "/AnotherStatisticOfAlarm", query: this.$route.query});
      // }
      // //加热炉
      // if (index == 'HeatingFurnaceGraph/HeatingFurnaceOtherParametersTrendGraph') {
      //   this.nowpos = '/HeatingFurnaceGraph/HeatingFurnaceOtherParametersTrendGraph';
      //   this.$router.push({path: "/HeatingFurnaceGraph/HeatingFurnaceOtherParametersTrendGraph", query: this.$route.query});
      // }
      // if (index == 'HeatingFurnaceGraph/HeatingFurnaceUnitOverviewMap') {
      //   this.nowpos = '/HeatingFurnaceGraph/HeatingFurnaceUnitOverviewMap';
      //   this.$router.push({path: "/HeatingFurnaceGraph/HeatingFurnaceUnitOverviewMap", query: this.$route.query});
      // }
      // //扶梯
      // if (index === 'EscalatorAlarmQueryGraph') {
      //   this.nowpos = '/EscalatorAlarmQueryGraph';
      //   this.$router.push({path: "/EscalatorAlarmQueryGraph", query: this.$route.query});
      // }
      // if (index === 'EscalatorTrendAnalysis') {
      //   this.nowpos = '/EscalatorTrendAnalysis';
      //   this.$router.push({path: "/EscalatorTrendAnalysis", query: this.$route.query});
      // }
      // if (index === 'EscalatorPumpImpactDiagnosis') {
      //   this.nowpos = '/EscalatorPumpImpactDiagnosis';
      //   this.$router.push({path: "/EscalatorPumpImpactDiagnosis", query: this.$route.query});
      // }
      // if (index === 'EscalatorRotorFaultDiagnosis') {
      //   this.nowpos = '/EscalatorRotorFaultDiagnosis';
      //   this.$router.push({path: "/EscalatorRotorFaultDiagnosis", query: this.$route.query});
      // }
      // if (index === 'EscalatorSingleMultiBarValueChart') {
      //   this.nowpos = '/EscalatorSingleMultiBarValueChart';
      //   this.$router.push({path: "/EscalatorSingleMultiBarValueChart", query: this.$route.query});
      // }
      // if (index === 'EscalatorOtherParametersTrendGraph') {
      //   this.nowpos = '/EscalatorOtherParametersTrendGraph';
      //   this.$router.push({path: "/EscalatorOtherParametersTrendGraph", query: this.$route.query});
      // }
      // if (index === 'EscalatorCepstrumGraph') {
      //   this.nowpos = '/EscalatorCepstrumGraph';
      //   this.$router.push({path: "/EscalatorCepstrumGraph", query: this.$route.query});
      // }
      // //机泵
      // if (index === 'UnitOverviewMap') {
      //   this.nowpos = '/UnitOverviewMap';
      //   this.$router.push({path: "/UnitOverviewMap", query: this.$route.query});
      // }
      // if (index === 'AlarmQueryGraph') {
      //   this.nowpos = '/AlarmQueryGraph';
      //   this.$router.push({path: "/AlarmQueryGraph", query: this.$route.query});
      // }
      // if (index === 'AnalysisGraph') {
      //   this.nowpos = '/AnalysisGraph';
      //   this.$router.push({path: "/AnalysisGraph", query: this.$route.query});
      // }
      // if (index === 'TrendAnalysis') {
      //   this.nowpos = '/TrendAnalysis';
      //   this.$router.push({path: "/TrendAnalysis", query: this.$route.query});
      // }
      // if (index === 'PumpImpactDiagnosis') {
      //   this.nowpos = '/PumpImpactDiagnosis';
      //   this.$router.push({path: "/PumpImpactDiagnosis", query: this.$route.query});
      // }
      //
      // if (index === 'VibrationMonitor') {
      //   this.nowpos = '/VibrationMonitor';
      //   this.$router.push({path: "/VibrationMonitor", query: this.$route.query});
      // }
      // if (index === 'RotorFaultDiagnosis') {
      //   this.nowpos = '/RotorFaultDiagnosis';
      //   this.$router.push({path: "/RotorFaultDiagnosis", query: this.$route.query});
      // }
      // if (index === 'ChangeVisualization') {
      //   this.nowpos = '/ChangeVisualization';
      //   this.$router.push({path: "/ChangeVisualization", query: this.$route.query});
      // }
      // if (index === 'SingleMultiBarValueChart') {
      //   this.nowpos = '/SingleMultiBarValueChart';
      //   this.$router.push({path: "/SingleMultiBarValueChart", query: this.$route.query});
      // }
      // if (index === 'ComprehensiveAnalysis') {
      //   this.nowpos = '/ComprehensiveAnalysis';
      //   this.$router.push({path: "/ComprehensiveAnalysis", query: this.$route.query});
      // }
      // if (index === 'MultiParametersTrendGraph') {
      //   this.nowpos = '/MultiParametersTrendGraph';
      //   this.$router.push({path: "/MultiParametersTrendGraph", query: this.$route.query});
      // }
      // if (index === 'OtherParametersTrendGraph') {
      //   this.nowpos = '/OtherParametersTrendGraph';
      //   this.$router.push({path: "/OtherParametersTrendGraph", query: this.$route.query});
      // }
      //
      // if (index === 'OrbitOfShaftCenter') {
      //   this.nowpos = '/OrbitOfShaftCenter';
      //   this.$router.push({path: "/OrbitOfShaftCenter", query: this.$route.query});
      //
      // }
      // if (index === 'StartstopGraph') {
      //   this.nowpos = '/StartstopGraph';
      //   this.$router.push({path: "/StartstopGraph", query: this.$route.query});
      //
      // }
      // if (index === 'RunSwordGraph') {
      //   this.nowpos = '/RunSwordGraph';
      //   this.$router.push({path: "/RunSwordGraph", query: this.$route.query});
      // }
      // if (index === 'RunStatusGraph') {
      //   this.nowpos = '/RunStatusGraph';
      //   this.$router.push({path: "/RunStatusGraph", query: this.$route.query});
      // }
      // if (index === 'CepstrumGraph') {
      //   this.nowpos = '/CepstrumGraph';
      //   this.$router.push({path: "/CepstrumGraph", query: this.$route.query});
      // }
      //
      // //以下是旋转图谱
      // if (index === 'RotatingMachineryGraph/RotatingVibrationMonitor') {
      //   this.nowpos = '/RotatingMachineryGraph/RotatingVibrationMonitor';
      //   this.$router.push({path: "/RotatingMachineryGraph/RotatingVibrationMonitor", query: this.$route.query});
      // }
      // if (index === 'RotatingMachineryGraph/VibrationHistoricalComparison') {
      //   this.nowpos = '/RotatingMachineryGraph/VibrationHistoricalComparison';
      //   this.$router.push({path: "/RotatingMachineryGraph/VibrationHistoricalComparison", query: this.$route.query});
      // }
      // if (index === 'RotatingMachineryGraph/SingleMultiBarValueChart') {
      //   this.nowpos = '/RotatingMachineryGraph/SingleMultiBarValueChart';
      //   this.$router.push({path: "/RotatingMachineryGraph/SingleMultiBarValueChart", query: this.$route.query});
      // }
      // if (index === 'RotatingMachineryGraph/OrbitOfShaftCenter1') {
      //   this.nowpos = '/RotatingMachineryGraph/OrbitOfShaftCenter1';
      //   this.$router.push({path: "/RotatingMachineryGraph/OrbitOfShaftCenter1", query: this.$route.query});
      // }
      // if (index === 'RotatingMachineryGraph/AxisPosition') {
      //   this.nowpos = '/RotatingMachineryGraph/AxisPosition';
      //   this.$router.push({path: "/RotatingMachineryGraph/AxisPosition", query: this.$route.query});
      // }
      // if (index === 'RotatingMachineryGraph/StartStopGraph') {
      //   this.nowpos = '/RotatingMachineryGraph/StartStopGraph';
      //   this.$router.push({path: "/RotatingMachineryGraph/StartStopGraph", query: this.$route.query});
      // }
      // if (index === 'RotatingMachineryGraph/RotatingComprehensiveAnalysis') {
      //   this.nowpos = '/RotatingMachineryGraph/RotatingComprehensiveAnalysis';
      //   this.$router.push({path: "/RotatingMachineryGraph/RotatingComprehensiveAnalysis", query: this.$route.query});
      // }
      // if (index === 'RotatingMachineryGraph/OtherParametersTrendGraph2') {
      //   this.nowpos = '/RotatingMachineryGraph/OtherParametersTrendGraph2';
      //   this.$router.push({path: "/RotatingMachineryGraph/OtherParametersTrendGraph2", query: this.$route.query});
      // }
      // if (index === 'RotatingMachineryGraph/AlarmQueryGraph2') {
      //   this.nowpos = '/RotatingMachineryGraph/AlarmQueryGraph2';
      //   this.$router.push({path: "/RotatingMachineryGraph/AlarmQueryGraph2", query: this.$route.query});
      // }
      // if (index === 'RotatingMachineryGraph/WholeSpectrumGraph') {
      //   this.nowpos = '/RotatingMachineryGraph/WholeSpectrumGraph';
      //   this.$router.push({path: "/RotatingMachineryGraph/WholeSpectrumGraph", query: this.$route.query});
      // }
      // if (index === 'RotatingMachineryGraph/TwoDimensionalHolography') {
      //   this.nowpos = '/RotatingMachineryGraph/TwoDimensionalHolography';
      //   this.$router.push({path: "/RotatingMachineryGraph/TwoDimensionalHolography", query: this.$route.query});
      // }
      // if (index === 'RotatingMachineryGraph/ThreeDimensionalHolography') {
      //   this.nowpos = '/RotatingMachineryGraph/ThreeDimensionalHolography';
      //   this.$router.push({path: "/RotatingMachineryGraph/ThreeDimensionalHolography", query: this.$route.query});
      // }
      // if (index === 'RotatingMachineryGraph/RotatingOverviewGrap') {
      //   this.nowpos = '/RotatingMachineryGraph/RotatingOverviewGrap';     //概貌图
      //   this.$router.push({path: "/RotatingMachineryGraph/RotatingOverviewGrap", query: this.$route.query});
      // }
      // if (index === 'RotatingMachineryGraph/RotatingRunStatusGraph') {
      //   this.nowpos = '/RotatingMachineryGraph/RotatingRunStatusGraph';          //运行状态
      //   this.$router.push({path: "/RotatingMachineryGraph/RotatingRunStatusGraph", query: this.$route.query});
      // }
      // if (index === 'RotatingMachineryGraph/DynamicBalancing') {
      //   this.nowpos = '/RotatingMachineryGraph/DynamicBalancing';          //现场动平衡
      //   this.$router.push({path: "/RotatingMachineryGraph/DynamicBalancing", query: this.$route.query});
      // }
      // if (index === 'RotatingMachineryGraph/TemperatureiDstributionField') {
      //   this.nowpos = '/RotatingMachineryGraph/TemperatureiDstributionField';
      //   this.$router.push({path: "/RotatingMachineryGraph/TemperatureiDstributionField", query: this.$route.query}); //温度分布场
      // }
      // if (index === 'RotatingMachineryGraph/ParameterComparisonQuery') {
      //   this.nowpos = '/RotatingMachineryGraph/ParameterComparisonQuery';          //参数比较查询
      //   this.$router.push({path: "/RotatingMachineryGraph/ParameterComparisonQuery", query: this.$route.query});
      // }
      // if (index == 'RotatingMachineryGraph/ImpactDiagnosis') { // 冲击诊断
      //   this.nowpos = '/RotatingMachineryGraph/ImpactDiagnosis';
      //   this.$router.push({path: "/RotatingMachineryGraph/ImpactDiagnosis", query: this.$route.query});
      // }
      // if (index == 'RotatingMachineryGraph/RotatingCepstrumGraph') { // 倒谱图
      //   this.nowpos = '/RotatingMachineryGraph/RotatingCepstrumGraph';
      //   this.$router.push({path: "/RotatingMachineryGraph/RotatingCepstrumGraph", query: this.$route.query});
      // }
      // if (index == 'RotatingMachineryGraph/RotatingHistoryTrendGraph') { //历史趋势图
      //   this.nowpos = '/RotatingMachineryGraph/RotatingHistoryTrendGraph';
      //   this.$router.push({path: "/RotatingMachineryGraph/RotatingHistoryTrendGraph", query: this.$route.query});
      // }
      //
      // //以下是燃气轮机
      // if (index === 'gasTurbineGraph/GasVibrationMonitor') {
      //   this.nowpos = '/gasTurbineGraph/GasVibrationMonitor';
      //   this.$router.push({path: "/gasTurbineGraph/GasVibrationMonitor", query: this.$route.query});
      // }
      // if (index === 'gasTurbineGraph/VibrationHistoricalComparison') {
      //   this.nowpos = '/gasTurbineGraph/VibrationHistoricalComparison';
      //   this.$router.push({path: "/gasTurbineGraph/VibrationHistoricalComparison", query: this.$route.query});
      // }
      // if (index === 'gasTurbineGraph/SingleMultiBarValueChart') {
      //   this.nowpos = '/gasTurbineGraph/GasSingleMultaBarGraph';
      //   this.$router.push({path: "/gasTurbineGraph/GasSingleMultaBarGraph", query: this.$route.query});
      // }
      // if (index === 'gasTurbineGraph/OrbitOfShaftCenter1') {
      //   this.nowpos = '/gasTurbineGraph/OrbitOfShaftCenter1';
      //   this.$router.push({path: "/gasTurbineGraph/OrbitOfShaftCenter1", query: this.$route.query});
      // }
      // if (index === 'gasTurbineGraph/AxisPosition') {
      //   this.nowpos = '/gasTurbineGraph/AxisPosition';
      //   this.$router.push({path: "/gasTurbineGraph/AxisPosition", query: this.$route.query});
      // }
      // if (index === 'gasTurbineGraph/StartStopGraph') {
      //   this.nowpos = '/gasTurbineGraph/StartStopGraph';
      //   this.$router.push({path: "/gasTurbineGraph/StartStopGraph", query: this.$route.query});
      // }
      // if (index === 'gasTurbineGraph/RotatingComprehensiveAnalysis') {
      //   this.nowpos = '/gasTurbineGraph/RotatingComprehensiveAnalysis';
      //   this.$router.push({path: "/gasTurbineGraph/RotatingComprehensiveAnalysis", query: this.$route.query});
      // }
      // if (index === 'gasTurbineGraph/OtherParametersTrendGraph2') {
      //   this.nowpos = '/gasTurbineGraph/OtherParametersTrendGraph2';
      //   this.$router.push({path: "/gasTurbineGraph/OtherParametersTrendGraph2", query: this.$route.query});
      // }
      // if (index === 'gasTurbineGraph/AlarmQueryGraph2') {
      //   this.nowpos = '/gasTurbineGraph/AlarmQueryGraph2';
      //   this.$router.push({path: "/gasTurbineGraph/AlarmQueryGraph2", query: this.$route.query});
      // }
      // if (index === 'gasTurbineGraph/WholeSpectrumGraph') {
      //   this.nowpos = '/gasTurbineGraph/WholeSpectrumGraph';
      //   this.$router.push({path: "/gasTurbineGraph/WholeSpectrumGraph", query: this.$route.query});
      // }
      // if (index === 'gasTurbineGraph/TwoDimensionalHolography') {
      //   this.nowpos = '/gasTurbineGraph/TwoDimensionalHolography';
      //   this.$router.push({path: "/gasTurbineGraph/TwoDimensionalHolography", query: this.$route.query});
      // }
      // if (index === 'gasTurbineGraph/ThreeDimensionalHolography') {
      //   this.nowpos = '/gasTurbineGraph/ThreeDimensionalHolography';
      //   this.$router.push({path: "/gasTurbineGraph/ThreeDimensionalHolography", query: this.$route.query});
      // }
      // if (index === 'gasTurbineGraph/GasOverviewGrap') {
      //   this.nowpos = '/gasTurbineGraph/GasOverviewGrap';     //概貌图
      //   this.$router.push({path: "/gasTurbineGraph/GasOverviewGrap", query: this.$route.query});
      // }
      // if (index === 'gasTurbineGraph/RotatingRunStatusGraph') {
      //   this.nowpos = '/gasTurbineGraph/RotatingRunStatusGraph';          //运行状态
      //   this.$router.push({path: "/gasTurbineGraph/RotatingRunStatusGraph", query: this.$route.query});
      // }
      // if (index === 'gasTurbineGraph/DynamicBalancing') {
      //   this.nowpos = '/gasTurbineGraph/DynamicBalancing';          //现场动平衡
      //   this.$router.push({path: "/gasTurbineGraph/DynamicBalancing", query: this.$route.query});
      // }
      // if (index === 'gasTurbineGraph/TemperatureiDstributionField1') {
      //   this.nowpos = '/gasTurbineGraph/TemperatureiDstributionField1';          //温度分布场
      //   this.$router.push({path: "/gasTurbineGraph/TemperatureiDstributionField1", query: this.$route.query});
      // }
      // if (index === 'gasTurbineGraph/ParameterComparisonQuery') {
      //   this.nowpos = '/gasTurbineGraph/ParameterComparisonQuery';          //参数比较查询
      //   this.$router.push({path: "/gasTurbineGraph/ParameterComparisonQuery", query: this.$route.query});
      // }
      //
      // //以下是柴油机和往复机，增加跳转路径请在这个上面加
      // //柴油机
      // if (index === 'DieselMonitorSystem/OverviewGraph') {
      //   this.nowpos = '/DieselMonitorSystem/OverviewGraph';
      //   this.$router.push({path: "/DieselMonitorSystem/OverviewGraph", query: this.$route.query});
      // }
      // if (index === 'DieselMonitorSystem/DieselMonitorRunStatus') {
      //   this.nowpos = '/DieselMonitorSystem/DieselMonitorRunStatus';
      //   this.$router.push({path: "/DieselMonitorSystem/DieselMonitorRunStatus", query: this.$route.query});
      // }
      // if (index === 'DieselMonitorSystem/HistoricalComparisonGraph') {
      //   this.nowpos = '/DieselMonitorSystem/HistoricalComparisonGraph';
      //   this.$router.push({path: "/DieselMonitorSystem/HistoricalComparisonGraph", query: this.$route.query});
      // }
      // if (index === 'DieselMonitorSystem/SingleValueStickGraph') {
      //   this.nowpos = '/DieselMonitorSystem/SingleValueStickGraph';
      //   this.$router.push({path: "/DieselMonitorSystem/SingleValueStickGraph", query: this.$route.query});
      // }
      // if (index === 'DieselMonitorSystem/DynamicPressureMonitorGraph') {
      //   this.nowpos = '/DieselMonitorSystem/DynamicPressureMonitorGraph';
      //   this.$router.push({path: "/DieselMonitorSystem/DynamicPressureMonitorGraph", query: this.$route.query});
      // }
      // if (index === 'DieselMonitorSystem/EventQueryGraph') {
      //   this.nowpos = '/DieselMonitorSystem/EventQueryGraph';
      //   this.$router.push({path: "/DieselMonitorSystem/EventQueryGraph", query: this.$route.query});
      // }
      // if (index === 'DieselMonitorSystem/VibrationMonitorGraph') {
      //   this.nowpos = '/DieselMonitorSystem/VibrationMonitorGraph';
      //   this.$router.push({path: "/DieselMonitorSystem/VibrationMonitorGraph", query: this.$route.query});
      // }
      // if (index === 'DieselMonitorSystem/InstantaneousSpeed') {
      //   this.nowpos = '/DieselMonitorSystem/InstantaneousSpeed';
      //   this.$router.push({path: "/DieselMonitorSystem/InstantaneousSpeed", query: this.$route.query});
      // }
      // if (index === 'DieselMonitorSystem/TorsionalVibration') {
      //   this.nowpos = '/DieselMonitorSystem/TorsionalVibration';
      //   this.$router.push({path: "/DieselMonitorSystem/TorsionalVibration", query: this.$route.query});
      // }
      // if (index === 'DieselMonitorSystem/MultiparameterAnalysis') {
      //   this.nowpos = '/DieselMonitorSystem/MultiparameterAnalysis';
      //   this.$router.push({path: "/DieselMonitorSystem/MultiparameterAnalysis", query: this.$route.query});
      // }
      // if (index === 'DieselMonitorSystem/ComprehensiveAnalysisGraph') {
      //   this.nowpos = '/DieselMonitorSystem/ComprehensiveAnalysisGraph';
      //   this.$router.push({path: "/DieselMonitorSystem/ComprehensiveAnalysisGraph", query: this.$route.query});
      // }
      // if (index === 'DieselMonitorSystem/IndicatorGraph') {
      //   this.nowpos = '/DieselMonitorSystem/IndicatorGraph';
      //   this.$router.push({path: "/DieselMonitorSystem/IndicatorGraph", query: this.$route.query});
      // }
      // if (index === 'DieselMonitorSystem/ImpactDiagnosis') {
      //   this.nowpos = '/DieselMonitorSystem/ImpactDiagnosis';
      //   this.$router.push({path: "/DieselMonitorSystem/ImpactDiagnosis", query: this.$route.query});
      // }
      // if (index === 'DieselMonitorSystem/OtherParametersTrend') {
      //   this.nowpos = '/DieselMonitorSystem/OtherParametersTrend';
      //   this.$router.push({path: "/DieselMonitorSystem/OtherParametersTrend", query: this.$route.query});
      // }
      // if (index === 'DieselMonitorSystem/AlarmQuery') {
      //   this.nowpos = '/DieselMonitorSystem/AlarmQuery';
      //   this.$router.push({path: "/DieselMonitorSystem/AlarmQuery", query: this.$route.query});
      // }
      // if (index === 'DieselMonitorSystem/OnAndOffStateAnalysis') {
      //   this.nowpos = '/DieselMonitorSystem/OnAndOffStateAnalysis';
      //   this.$router.push({path: "/DieselMonitorSystem/OnAndOffStateAnalysis", query: this.$route.query});
      // }
      // if (index === 'DieselMonitorSystem/StartAndStopTimeQuery') {
      //   this.nowpos = '/DieselMonitorSystem/StartAndStopTimeQuery';
      //   this.$router.push({path: "/DieselMonitorSystem/StartAndStopTimeQuery", query: this.$route.query});
      // }
      //
      // //往复机
      // if (index === 'ReciprocatMachineryGraph/OverviewGraph1') {
      //   this.nowpos = '/ReciprocatMachineryGraph/OverviewGraph1';
      //   this.$router.push({path: "/ReciprocatMachineryGraph/OverviewGraph1", query: this.$route.query});
      // }
      // if (index === 'ReciprocatMachineryGraph/ReciprocatAlarmQuery') {
      //   this.nowpos = '/ReciprocatMachineryGraph/ReciprocatAlarmQuery';
      //   this.$router.push({path: "/ReciprocatMachineryGraph/ReciprocatAlarmQuery", query: this.$route.query});
      // }
      // if (index === 'ReciprocatMachineryGraph/RunStatusGraph1') {
      //   this.nowpos = '/ReciprocatMachineryGraph/RunStatusGraph1';
      //   this.$router.push({path: "/ReciprocatMachineryGraph/RunStatusGraph1", query: this.$route.query});
      // }
      // if (index === 'ReciprocatMachineryGraph/HistoricalComparisonGraph1') {
      //   this.nowpos = '/ReciprocatMachineryGraph/HistoricalComparisonGraph1';
      //   this.$router.push({path: "/ReciprocatMachineryGraph/HistoricalComparisonGraph1", query: this.$route.query});
      // }
      // if (index === 'ReciprocatMachineryGraph/SingleValueStickGraph1') {
      //   this.nowpos = '/ReciprocatMachineryGraph/SingleValueStickGraph1';
      //   this.$router.push({path: "/ReciprocatMachineryGraph/SingleValueStickGraph1", query: this.$route.query});
      // }
      // if (index === 'ReciprocatMachineryGraph/PistonRodSettlement') {
      //   this.nowpos = '/ReciprocatMachineryGraph/PistonRodSettlement';
      //   this.$router.push({path: "/ReciprocatMachineryGraph/PistonRodSettlement", query: this.$route.query});
      // }
      // if (index === 'ReciprocatMachineryGraph/ReciprocatVibrationMonitor') {
      //   this.nowpos = '/ReciprocatMachineryGraph/ReciprocatVibrationMonitor';
      //   this.$router.push({path: "/ReciprocatMachineryGraph/ReciprocatVibrationMonitor", query: this.$route.query});
      // }
      // if (index === 'ReciprocatMachineryGraph/MultiparameterAnalysis1') {
      //   this.nowpos = '/ReciprocatMachineryGraph/MultiparameterAnalysis1';
      //   this.$router.push({path: "/ReciprocatMachineryGraph/MultiparameterAnalysis1", query: this.$route.query});
      // }
      // if (index === 'ReciprocatMachineryGraph/ReciprocatComprehensiveAnalysis') {
      //   this.nowpos = '/ReciprocatMachineryGraph/ReciprocatComprehensiveAnalysis';
      //   this.$router.push({path: "/ReciprocatMachineryGraph/ReciprocatComprehensiveAnalysis", query: this.$route.query});
      // }
      // if (index === 'ReciprocatMachineryGraph/OtherParametersTrend1') {
      //   this.nowpos = '/ReciprocatMachineryGraph/OtherParametersTrend1';
      //   this.$router.push({path: "/ReciprocatMachineryGraph/OtherParametersTrend1", query: this.$route.query});
      // }
      // if (index === 'ReciprocatMachineryGraph/PistonRodTrackGraph') {
      //   this.nowpos = '/ReciprocatMachineryGraph/PistonRodTrackGraph';
      //   this.$router.push({path: "/ReciprocatMachineryGraph/PistonRodTrackGraph", query: this.$route.query});
      // }
      // if (index === 'ReciprocatMachineryGraph/IndicatorGraph1') {
      //   this.nowpos = '/ReciprocatMachineryGraph/IndicatorGraph1';
      //   this.$router.push({path: "/ReciprocatMachineryGraph/IndicatorGraph1", query: this.$route.query});
      // }
      // if (index === 'ReciprocatMachineryGraph/ImpactDiagnosis1') {
      //   this.nowpos = '/ReciprocatMachineryGraph/ImpactDiagnosis1';
      //   this.$router.push({path: "/ReciprocatMachineryGraph/ImpactDiagnosis1", query: this.$route.query});
      // }
      // if (index === 'ReciprocatMachineryGraph/StressMonitoring') {
      //   this.nowpos = '/ReciprocatMachineryGraph/StressMonitoring';
      //   this.$router.push({path: "/ReciprocatMachineryGraph/StressMonitoring", query: this.$route.query});
      // }
      //
      //
      // //注意在柴油机和往复机上面加跳转路径，请看上一条注释
      //
      // //在线报告报表
      // if (index === 'MachineMonthReport') {
      //   this.nowpos = '/MachineMonthReport';
      //   this.$router.push({path: "/MachineMonthReport"});
      // }
      // if (index === 'VibrationParameterReport') {
      //   this.nowpos = '/VibrationParameterReport';
      //   this.$router.push({path: "/VibrationParameterReport"});
      // }
      // if (index === 'FactoryReport') {
      //   this.nowpos = '/FactoryReport';
      //   this.$router.push({path: "/FactoryReport"});
      // }
      //
      // // 离线
      // if (index === 'Offline/OLUnitOverviewMap') {
      //   this.nowpos = '/Offline/OLUnitOverviewMap';
      //   this.$router.push({path: "/Offline/OLUnitOverviewMap", query: this.$route.query});
      // }
      // if (index === 'Offline/OLVibrationTrend') {
      //   this.nowpos = '/Offline/OLVibrationTrend';
      //   this.$router.push({path: "/Offline/OLVibrationTrend", query: this.$route.query});
      // }
      // if (index === 'Offline/OLEnvelopeAnalysis') {
      //   this.nowpos = '/Offline/OLEnvelopeAnalysis';
      //   this.$router.push({path: "/Offline/OLEnvelopeAnalysis", query: this.$route.query});
      // }
      // if (index === 'Offline/OLRetardedVariablesTrend') {
      //   this.nowpos = '/Offline/OLRetardedVariablesTrend';
      //   this.$router.push({path: "/Offline/OLRetardedVariablesTrend", query: this.$route.query});
      // }
      // if (index === 'Offline/OLAlarmQueryAnalysis') {
      //   this.nowpos = '/Offline/OLAlarmQueryAnalysis';
      //   this.$router.push({path: "/Offline/OLAlarmQueryAnalysis", query: this.$route.query});
      // }
      // if (index === 'Offline/OLComparativeAnalysis') {
      //   this.nowpos = '/Offline/OLComparativeAnalysis';
      //   this.$router.push({path: "/Offline/OLComparativeAnalysis", query: this.$route.query});
      // }
      // if (index === 'Offline/OLComparisonAnalysis') {
      //   this.nowpos = '/Offline/OLComparisonAnalysis';
      //   this.$router.push({path: "/Offline/OLComparisonAnalysis", query: this.$route.query});
      // }
      // if (index === 'Offline/OLOrbitOfShaftCenter') {
      //   this.nowpos = '/Offline/OLOrbitOfShaftCenter';
      //   this.$router.push({path: "/Offline/OLOrbitOfShaftCenter", query: this.$route.query});
      // }
      // if (index === 'Offline/OLManualEntry') {
      //   this.nowpos = '/Offline/OLManualEntry';
      //   this.$router.push({path: "/Offline/OLManualEntry", query: this.$route.query});
      // }
      // if (index === 'Offline/OLWallThicknessTrend') {
      //   this.nowpos = '/Offline/OLWallThicknessTrend';
      //   this.$router.push({path: "/Offline/OLWallThicknessTrend", query: this.$route.query});
      // }
      // // 离线结束
      //
      // // 无线机泵
      // if (index === 'WirelessPumpGraph/WirelessPumpUnitOverviewMap') {
      //   this.nowpos = '/WirelessPumpGraph/WirelessPumpUnitOverviewMap';
      //   this.$router.push({path: "/WirelessPumpGraph/WirelessPumpUnitOverviewMap", query: this.$route.query});
      // }
      // if (index === 'WirelessPumpGraph/WirelessPumpAlarmQueryGraph') {
      //   this.nowpos = '/WirelessPumpGraph/WirelessPumpAlarmQueryGraph';
      //   this.$router.push({path: "/WirelessPumpGraph/WirelessPumpAlarmQueryGraph", query: this.$route.query});
      // }
      // if (index === 'WirelessPumpGraph/WirelessPumpTrendAnalysis') {
      //   this.nowpos = '/WirelessPumpGraph/WirelessPumpTrendAnalysis';
      //   this.$router.push({path: "/WirelessPumpGraph/WirelessPumpTrendAnalysis", query: this.$route.query});
      // }
      // if (index === 'WirelessPumpGraph/WirelessPumpImpactDiagnosis') {
      //   this.nowpos = '/WirelessPumpGraph/WirelessPumpImpactDiagnosis';
      //   this.$router.push({path: "/WirelessPumpGraph/WirelessPumpImpactDiagnosis", query: this.$route.query});
      // }
      // if (index === 'WirelessPumpGraph/WirelessPumpOtherParametersTrendGraph') {
      //   this.nowpos = '/WirelessPumpGraph/WirelessPumpOtherParametersTrendGraph';
      //   this.$router.push({path: "/WirelessPumpGraph/WirelessPumpOtherParametersTrendGraph", query: this.$route.query});
      // }
      // if (index === 'WirelessPumpGraph/WaveformSpectraComparativeAnalysis') {
      //   this.nowpos = 'WirelessPumpGraph/WaveformSpectraComparativeAnalysis';
      //   this.$router.push({path: "/WirelessPumpGraph/WaveformSpectraComparativeAnalysis", query: this.$route.query});
      // }
      // if (index === 'WirelessPumpGraph/WirelessPumpEdgeComputingGraph') {
      //   this.nowpos = 'WirelessPumpGraph/WirelessPumpEdgeComputingGraph';
      //   this.$router.push({path: "/WirelessPumpGraph/WirelessPumpEdgeComputingGraph", query: this.$route.query});
      // }
    },
    handleTopic(index) {
      this.$store.state.topiccolor = index
      this.$router.push({
        query: {
          equipmentUuid: this.nowequid,
          topic: this.$store.state.topiccolor,
          language: this.$store.state.language
        }
      })
      this.changeTopic(index);
    },
    changeflag() {
      if (this.showMenu === true) {
        this.showMenu = false;
        this.$store.commit('setflagopleft', false);
        this.$store.commit('setmarginleftvalue', '10%');
        this.$store.state.showOp = false;
      } else {
        this.showMenu = true;
        this.$store.commit('setflagopleft');
        if (!this.$store.state.flaggraph && this.$store.state.flagporight && this.$store.state.flagopleft) {
          this.$store.commit('setmarginleftvalue', '0%');
        }
        this.$store.state.showOp = true;
      }
    },
    setOpPage(param) {
      if (param === false) {
        document.getElementById("lefttupu").style.width = 'calc(100% - 12px)';
      } else {
        document.getElementById("lefttupu").style.width = 'calc(100% - 302px)';
      }
    },
    getBearingInfo() {
      let bearingInfo
      if (this.BEARING_ID && this.$store.state.bearingInfoList[this.BEARING_ID]) {
        bearingInfo = this.$store.state.bearingInfoList[this.BEARING_ID]
        let n = Number(this.BEARING_REV)//转速
        let z = bearingInfo.ELEMENTS_NUM//Z滚动体数量
        let D = bearingInfo.PITCH_DIAMETER//D滚动轴承的节圆直径
        let d = bearingInfo.ELEMENT_DIAMETER//d滚动体直径
        let a = bearingInfo.ELEMENT_DIAMETER//α接触角
        if (!this.BEARING_REV || isNaN(Number(this.BEARING_REV))) {
          this.fi = ''
          this.fo = ''
          this.fe = ''
          this.fc = ''
          this.innerValue = ''
          this.rollingValue = ''
          this.outerValue = ''
          this.cageValue = ''
          this.$message.error(this.translateText('textMap.', '请输入正确的转速!'))
        } else if (d == 0 || D == 0) {
          this.$message.error(this.translateText('textMap.', '滚动体直径或滚动轴承的节圆直径不能为0!'))
        } else {
          this.fi = parseFloat((n * z) / 120 * (1 + d * Math.cos(a) / D)).toFixed(2)
          this.fo = parseFloat((n * z) / 120 * (1 - d * Math.cos(a) / D)).toFixed(2)
          this.fe = parseFloat((n * D) / 120 / d * (1 - d * d * Math.cos(a) * Math.cos(a) / (D * D))).toFixed(2)
          this.fc = parseFloat(n / 120 * (1 - d * Math.cos(a) / D)).toFixed(2)
          this.innerValue = parseFloat(this.fi / (n / 60)).toFixed(2) //内圈
          this.outerValue = parseFloat(this.fo / (n / 60)).toFixed(2)//外圈
          this.rollingValue = parseFloat(this.fe / (n / 60)).toFixed(2)//滚动体
          this.cageValue = parseFloat(this.fc / (n / 60)).toFixed(2)//保持架
        }
      } else {
        this.fi = ''
        this.fo = ''
        this.fe = ''
        this.fc = ''
        this.innerValue = ''
        this.rollingValue = ''
        this.outerValue = ''
        this.cageValue = ''
        this.$message.error(this.translateText('textMap.', '请输入正确的轴承型号'))
      }
    },
    saveChartParameter() {
      this.$refs.eventForm.validate((valid) => {
        if (valid) {
          this.saveLoading = true
          // 将转速和备注添加到info中
          this.$store.state.postData.name = this.$store.state.eventName
          this.$store.state.postData.info.rev = this.$store.state.currentRev
          this.$store.state.postData.info.description = this.$store.state.eventDescription

          this.$axios.post('/mark/add', this.$store.state.postData).then(res => {
            if (res.data.code === 200) {
              this.$message.success(this.translateText('textMap.', '保存成功'))
              this.$store.state.showEventDialogFlag = false
              this.$store.state.eventName = ''
              this.$store.state.eventDescription = ''
              this.$store.state.sampleRefreshFlag = Date.now()
            } else {
              this.$message.error(res.data.message)
            }
          }).catch(e => {
            console.log(e)
            if (e.response && e.response.data && e.response.data.message) {
              this.$message.error(e.response.data.message)
            } else {
              this.$message.error(this.translateText('textMap.', '保存失败'))
            }
          }).finally(() => {
            this.saveLoading = false
          })
        } else {
          console.log('表单验证失败');
          return false;
        }
      });
    },

    // 关闭基准数据信息弹窗
    closeEventDialog() {
      this.$store.state.showEventDialogFlag = false;
    },

    // 获取对话框按钮样式
    getDialogButtonStyle(type) {
      const theme = {
        bgColor: this.$store.state.leftconbgcolor,
        textColor: this.$store.state.textcolor,
        borderColor: this.$store.state.selectbordercolor,
        buttonColor: this.$store.state.buttoncolor,
        buttonTextColor: this.$store.state.buttontextcolor,
        inputBgColor: this.$store.state.inputbgcolor,
        hoverColor: this.$store.state.pointcolor
      };

      let buttonStyle = {
        borderRadius: '8px',
        width: '80px',
        borderWidth: '1px',
        borderStyle: 'solid',
        padding: '8px 0'
      };

      if (type === 'cancel') {
        // 根据主题设置取消按钮样式
        switch(this.$store.state.topiccolor) {
          case 'high-ash':
          case 'dark':
            // 暗色主题样式
            buttonStyle.backgroundColor = '#17181b';
            buttonStyle.color = '#ffffff';
            buttonStyle.borderColor = '#dde2e9';
            break;
          case 'quiet-blue':
          case 'blue':
            // 蓝色主题样式
            buttonStyle.backgroundColor = '#011e5a';
            buttonStyle.color = '#ffffff';
            buttonStyle.borderColor = '#0042ad';
            break;
          default:
            // 默认主题样式
            buttonStyle.backgroundColor = '#ffffff';
            buttonStyle.color = '#606266';
            buttonStyle.borderColor = '#4d81fa';
        }
      } else if (type === 'confirm') {
        // 根据主题设置确认按钮样式
        switch(this.$store.state.topiccolor) {
          case 'high-ash':
          case 'dark':
            // 暗色主题样式
            buttonStyle.backgroundColor = '#f1f5ff';
            buttonStyle.color = '#222331';
            buttonStyle.borderColor = '#47484b';
            break;
          case 'quiet-blue':
          case 'blue':
            // 蓝色主题样式
            buttonStyle.backgroundColor = '#0c56d0';
            buttonStyle.color = '#ffffff';
            buttonStyle.borderColor = '#324057';
            break;
          default:
            // 默认主题样式，使用原有主题变量
            buttonStyle.backgroundColor = theme.buttonColor;
            buttonStyle.color = theme.buttonTextColor;
            buttonStyle.borderColor = theme.buttonColor;
        }
      }

      return buttonStyle;
    },

    // 设置主题CSS变量
    setEventDialogTheme() {
      const root = document.documentElement;
      root.style.setProperty('--bgcolor', this.$store.state.bgcolor);
      root.style.setProperty('--conbgcolor', this.$store.state.conbgcolor);
      root.style.setProperty('--leftconbgcolor', this.$store.state.leftconbgcolor);
      root.style.setProperty('--textcolor', this.$store.state.textcolor);
      root.style.setProperty('--activetextcolor', this.$store.state.activetextcolor);
      root.style.setProperty('--buttoncolor', this.$store.state.buttoncolor);
      root.style.setProperty('--buttontextcolor', this.$store.state.buttontextcolor);
      root.style.setProperty('--pointcolor', this.$store.state.pointcolor);
      root.style.setProperty('--selectbordercolor', this.$store.state.selectbordercolor);
      root.style.setProperty('--selectbordercolorone', this.$store.state.selectbordercolorone || this.$store.state.selectbordercolor);
      root.style.setProperty('--scrollbarbgcolor', this.$store.state.scrollbarbgcolor);
      root.style.setProperty('--scrollbarthumbbgcolor', this.$store.state.scrollbarthumbbgcolor);

      let headerBgColor = '#f5f7fa';
      // 根据主题设置弹窗字体颜色
      let dialogTextColor = this.$store.state.textcolor;
      switch(this.$store.state.topiccolor) {
        case 'high-ash':
        case 'dark':
        case 'gray':
        case 'ash':
          headerBgColor = 'rgba(48,49,51,0)';
          dialogTextColor = '#b7bac0';
          break;
        case 'quiet-blue':
        case 'blue':
          headerBgColor = '#1f2d3d';
          dialogTextColor = '#b7bac0';
          break;
        case 'simple-white':
        case 'white':
          headerBgColor = '#f5f7fa';
          dialogTextColor = '#303133';
          break;
        default:
          headerBgColor = '#f5f7fa';
          dialogTextColor = '#303133';
      }
      root.style.setProperty('--headerbgcolor', headerBgColor);

      // 直接更新弹窗CSS变量
      const eventInfoDialog = document.querySelector('.event-info .el-dialog');
      if (eventInfoDialog) {
        eventInfoDialog.style.setProperty('--dialog-bgcolor', this.$store.state.leftconbgcolor);
        eventInfoDialog.style.setProperty('--dialog-textcolor', dialogTextColor);
        eventInfoDialog.style.setProperty('--dialog-bordercolor', this.$store.state.selectbordercolor);
        eventInfoDialog.style.setProperty('--dialog-btncolor', this.$store.state.buttoncolor);
        eventInfoDialog.style.setProperty('--dialog-placeholder-color', dialogTextColor + '80');
        eventInfoDialog.style.setProperty('--dialog-focus-color', this.$store.state.buttoncolor);
      }

      // 无论弹窗是否可见，都应用主题样式
      this.$nextTick(() => {
        this.applyEventDialogThemeStyles();
      });
    },

    // 应用主题样式到基准数据信息弹窗
    applyEventDialogThemeStyles() {
      const theme = {
        bgColor: this.$store.state.leftconbgcolor,
        textColor: this.$store.state.textcolor,
        borderColor: this.$store.state.selectbordercolor,
        borderColorOne: this.$store.state.selectbordercolorone || this.$store.state.selectbordercolor,
        buttonColor: this.$store.state.buttoncolor,
        inputBgColor: this.$store.state.inputbgcolor,
        hoverColor: this.$store.state.pointcolor
      };

      // 根据主题设置弹窗字体颜色
      let dialogTextColor = theme.textColor;
      switch(this.$store.state.topiccolor) {
        case 'high-ash':
        case 'dark':
        case 'gray':
        case 'ash':
          dialogTextColor = '#b7bac0';
          break;
        case 'quiet-blue':
        case 'blue':
          dialogTextColor = '#b7bac0';
          break;
        case 'simple-white':
        case 'white':
          dialogTextColor = '#303133';
          break;
        default:
          dialogTextColor = '#303133';
      }

      // 应用样式到弹窗元素
      const dialogEl = document.querySelector('.event-info .el-dialog');
      if (dialogEl) {
        dialogEl.style.backgroundColor = theme.bgColor;
        dialogEl.style.color = dialogTextColor;
        // 设置弹窗外边框样式
        dialogEl.style.borderWidth = '2px';
        dialogEl.style.borderStyle = 'solid';
        let borderColor = theme.borderColor;
        switch(this.$store.state.topiccolor) {
          case 'high-ash':
          case 'dark':
            borderColor = '#66686c';
            break;
          case 'quiet-blue':
          case 'blue':
            borderColor = '#0FA9D81C';
            break;
          default:
            borderColor = '#d8dce2';
        }
        dialogEl.style.borderColor = borderColor;
      }

      const dialogBodyEl = document.querySelector('.event-info .el-dialog__body');
      if (dialogBodyEl) {
        dialogBodyEl.style.backgroundColor = theme.bgColor;
        dialogBodyEl.style.color = dialogTextColor;
      }

      const dialogHeaderEl = document.querySelector('.event-info .el-dialog__header');
      if (dialogHeaderEl) {
        dialogHeaderEl.style.backgroundColor = theme.bgColor;

        // 根据主题设置不同的边框样式
        let borderStyle = '1px solid';
        let borderColor = theme.borderColor;

        switch(this.$store.state.topiccolor) {
          case 'high-ash':
          case 'dark':
            borderStyle = '1px solid';
            borderColor = '#66686c';
            break;
          case 'quiet-blue':
          case 'blue':
            borderStyle = '1px solid';
            borderColor = '#0fa9d840';
            break;
          default:
            borderStyle = '1px solid';
            borderColor = '#d8dce2';
        }

        dialogHeaderEl.style.borderBottom = `${borderStyle} ${borderColor}`;

        const dialogTitleEl = dialogHeaderEl.querySelector('.el-dialog__title');
        if (dialogTitleEl) {
          dialogTitleEl.style.color = dialogTextColor;
        }
      }

      const dialogFooterEl = document.querySelector('.event-info .el-dialog__footer');
      if (dialogFooterEl) {
        dialogFooterEl.style.backgroundColor = theme.bgColor;

        // 根据主题设置不同的边框样式
        let borderStyle = '1px solid';
        let borderColor = '#e4e7ed';

        if (this.$store.state.topiccolor === 'high-ash' || this.$store.state.topiccolor === 'dark') {
          borderColor = '#66686c';
        } else if (this.$store.state.topiccolor === 'quiet-blue' || this.$store.state.topiccolor === 'blue') {
          borderColor = '#4a5a7a';
        }

        dialogFooterEl.style.borderTop = `${borderStyle} ${borderColor}`;
      }

      // 应用字体颜色到表单标签
      const formLabels = document.querySelectorAll('.event-info .el-form-item__label');
      formLabels.forEach(label => {
        label.style.color = dialogTextColor;
      });

      // 应用字体颜色到输入框
      const inputInnerElements = document.querySelectorAll('.event-info .el-input__inner');
      inputInnerElements.forEach(input => {
        input.style.color = dialogTextColor;
        // 设置placeholder颜色
        const placeholderColor = dialogTextColor + '80';
        input.style.color = dialogTextColor;
        input.style.setProperty('color', dialogTextColor);
        // 使用CSS变量设置placeholder颜色
        input.style.setProperty('--dialog-placeholder-color', placeholderColor);
      });

      // 应用字体颜色到输入框容器，确保CSS变量生效
      const inputContainerElements = document.querySelectorAll('.event-info .el-input');
      inputContainerElements.forEach(input => {
        const placeholderColor = dialogTextColor + '80';
        input.style.setProperty('--dialog-placeholder-color', placeholderColor);
      });

      // 应用字体颜色到其他文本元素
      const textElements = document.querySelectorAll('.event-info .el-dialog__body *');
      textElements.forEach(element => {
        if (element.tagName !== 'INPUT' && element.tagName !== 'BUTTON' && element.tagName !== 'SELECT' && element.tagName !== 'TEXTAREA') {
          element.style.color = dialogTextColor;
        }
      });

      const errorElements = document.querySelectorAll('.event-info .el-form-item__error');
      errorElements.forEach(error => {
        error.style.color = '#f56c6c';
      });
    }


  },
  components: {
    PlantTree,
  },
}
</script>

<style lang="scss">
.box {
  --labelcolor: #696B6F;
  --treeinputbgcolor: #ffffff;
  --bgcolor: #222331;
  --conbgcolor: #0D0F1F;
  --leftconbgcolor: #222331;
  --buttoncolor: #1677FF;
  --activetextcolor: #1677FF;
  --scrollbarbgcolor: rgba(193, 193, 193, 0.2);
  --scrollbarthumbbgcolor: rgba(193, 193, 193, 1);
  // --bgcolor: '';
  // --conbgcolor: '';
  // --leftconbgcolor: '';
  display: flex;
  height: 100%;
  overflow: hidden;

  .el-header {
    padding: 0;
    background-color: var(--bgcolor);
    color: #fff;
    line-height: 48px;
    font-size: 24px;
    font-weight: bold;
    overflow-x: auto; /* 允许横向滚动 */
    overflow-y: hidden; /* 隐藏垂直滚动条 */
    white-space: nowrap; /* 确保所有内容在同一行 */
    transition: transform 0.5s ease; /* 平滑滚动动画 */
    width: 100%; /* 占满整个容器宽度 */
    display: flex; /* 使用 flex 布局 */
    align-items: center; /* 垂直居中对齐 */


    .el-menu-demo {
      height: 100%;
      display: flex; /* 使用 flex 布局 */
      align-items: center; /* 垂直居中对齐 */
    }

    .my-div1 {
      display: flex; /* 使用 flex 布局 */
      align-items: center; /* 垂直居中对齐 */
      flex-grow: 1; /* 让 .my-div1 占据剩余空间 */

    }
  }

  .content {
    // height: 100%;
    position: relative;
    height: calc(100% - 80px);
    background-color: var(--conbgcolor);
  }

  .left-aside {
    height: calc(100% - 10px);
    display: flex;
    flex-direction: column;
    flex-wrap: wrap; /* 自动换行 */
    margin-top: 10px;

    .left-title {
      margin-bottom: 1px;
      padding: 6px 16px;
      display: flex;
      align-items: center;
      gap: 10px;
      background: var(--leftconbgcolor);
      box-shadow: 0 1px 1px 0 var(--conbgcolor);
      color: var(--textcolor);
    }

    .left-title-txt {
      color: var(--activetextcolor);
      height: auto;
      font-family: "Microsoft YaHei";
      font-size: 16px;
      font-weight: 700;
    }

    .left-content {
      flex: 1;
      background: var(--leftconbgcolor);
      overflow: auto;
    }

    .left-content::-webkit-scrollbar {
      background-color: var(--leftconbgcolor);
    }

    .left-content::-webkit-scrollbar-thumb {
      background-color: var(--leftconbgcolor);
    }

    .menu-hide {
      height: 100%;
      width: 10px;
      float: left;
      background-color: var(--conbgcolor);
      display: flex;
      align-items: center;

      .op-btn {
        height: 100%;
        width: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        cursor: pointer;
      }

      .op-btn-svg {
        position: absolute;
      }

      .op-button {
        transform: perspective(0.5em) rotateY(16deg);
        width: 10px;
        height: 66px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: var(--leftconbgcolor);
        color: var(--buttoncolor);
        position: absolute;
        cursor: pointer;
      }
    }
  }

  .el-menu.el-menu--horizontal {
    border-bottom: solid 0px #303749;
  }

  .el-menu--horizontal > .el-submenu .el-submenu__title {
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    padding: 0 16px;
    height: 48px;
    line-height: 48px;
  }

  .el-aside {
    color: #333;
    text-align: center;
    line-height: 205px;
    border: 1px solid #303749;
  }

  .el-main {
    padding: 0;
    /*border: 1px solid #2F4554;*/

  }

  .main {
    flex: 1;
    height: 100%;
    width: calc(100% - 240px);
    background: var(--leftconbgcolor);
  }

  //.el-form-item__label {
  //  white-space: normal !important; /* 允许自动换行 */
  //  width: auto;                     /* 可选：让宽度自适应 */
  //  word-break: break-all;           /* 可选：长英文自动换行 */
  //}

  .trees {
    width: 100%;
    //height: 100%;
    height: calc(100% - 10px);
  }

  .el-dialog__header {
    padding: 10px 10px;
  }

  .el-dialog__body {
    padding: 10px 10px;
  }

  //  数据加载样式
  .data-loading,
  .datafail {
    z-index: 3;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 200px;
    height: 50px;
    color: var(--labelcolor);
    background-color: var(--treeinputbgcolor);
    line-height: 50px;
    text-align: center;
  }

  .customTip {
    z-index: 3;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 50px;
    color: var(--labelcolor);
    background-color: var(--treeinputbgcolor);
    line-height: 50px;
    text-align: center;
  }

  .bearing-info {
    .bearing-form {
      .el-form-item {
        display: flex;
      }

      .el-form-item__label {
        //text-align: left;
      }

      .el-form-item__content {
        flex: 1;
      }

      .el-select {
        width: 100%;
      }

      .my-form-item-group {
        display: flex;
      }

      .my-form-item-group > * {
        flex: 1; /* 平均分配子元素的空间 */
        margin-right: 10px; /* 可选：控制子元素之间的间距 */
      }
    }
  }

  .event-info {
    .el-dialog {
      background-color: var(--dialog-bgcolor);
      color: var(--dialog-textcolor);
      border-color: var(--dialog-bordercolor);
      border-width: 2px;
      border-style: solid;
    }

    .el-dialog__header {
      background-color: var(--dialog-bgcolor);
      border-bottom: 1px solid var(--dialog-bordercolor);
    }

    .el-dialog__title {
      color: var(--dialog-textcolor);
      font-size: 16px;
    }

    /* 表尾边框 */
    .el-dialog__footer {
      background-color: var(--dialog-bgcolor);
      border-top: 1px solid var(--dialog-bordercolor);
    }

    /* 关闭按钮位置调整 */
    .el-dialog__headerbtn {
      position: absolute;
      top: 10px;
      right: 15px;
      font-size: 20px;
      padding: 0;
      margin: 0;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: var(--dialog-textcolor);
      font-size: 24px;
      width: 30px;
      height: 30px;
      line-height: 30px;
      border-radius: 4px;
      transition: all 0.3s;
      margin: 0;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .el-dialog__headerbtn .el-dialog__close:hover {
      background-color: rgba(0, 0, 0, 0.1);
      color: var(--dialog-btncolor);
    }

    .el-dialog__body {
      background-color: var(--dialog-bgcolor);
      color: var(--dialog-textcolor);
    }

    .el-dialog__footer {
      background-color: var(--dialog-bgcolor);
      border-top-color: var(--dialog-bordercolor);
    }

    .event-form {
      .el-form-item {
        display: flex;
        align-items: flex-start;
        margin-bottom: 20px;
        white-space: nowrap;
        color: var(--dialog-textcolor);
      }

      .el-form-item__label {
        width: 140px;
        text-align: right;
        padding-right: 15px;
        font-weight: bold;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: var(--dialog-textcolor);
        font-size: 14px;
        padding-top: 7px;
        margin-bottom: 0;
        line-height: 1;
      }

      .el-form-item__content {
        flex: 1;
        width: 0;
        min-width: 300px;
        color: var(--dialog-textcolor);
      }

      .el-input {
        width: 90%;
      }

      .el-select {
        width: 90%;
      }

      .el-textarea {
        width: 90%;
      }

      /* 输入框样式优化 */
      .el-input__inner,
      .el-textarea__inner {
        background-color: var(--dialog-bgcolor) !important;
        color: var(--dialog-textcolor) !important;
        border-color: var(--dialog-input-bordercolor) !important;
      }

      .el-input__inner::placeholder,
      .el-textarea__inner::placeholder {
        color: var(--dialog-placeholder-color) !important;
      }

      .el-input__inner:focus,
      .el-textarea__inner:focus {
        border-color: var(--dialog-focus-color) !important;
        box-shadow: 0 0 0 2px var(--dialog-focus-color) 30 !important;
      }

      /* 禁用状态优化 */
      .el-input.is-disabled .el-input__inner {
        background-color: var(--dialog-bgcolor) !important;
        color: var(--dialog-textcolor) !important;
        border-color: var(--dialog-bordercolor) !important;
        opacity: 0.8;
      }

      /* 必填项样式 */
      .required-field .el-input__inner {
        border-color: var(--dialog-bordercolor) !important;
      }

      /* 错误提示始终是红色 */
      .el-form-item__error {
        color: #f56c6c !important;
      }

      .required-asterisk {
        color: #ff4d4f;
        margin-left: 4px;
      }

      .el-input__inner {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      /* 按钮样式优化 */
      .el-button--primary {
        background-color: var(--dialog-btncolor) !important;
        border-color: var(--dialog-btncolor) !important;
        color: var(--dialog-textcolor) !important;
      }

      .el-button--primary:hover,
      .el-button--primary:focus {
        background-color: var(--dialog-btncolor) !important;
        border-color: var(--dialog-btncolor) !important;
        opacity: 0.9;
        box-shadow: 0 0 0 2px var(--dialog-btncolor) 30 !important;
      }

      .el-button--primary:active {
        background-color: var(--dialog-btncolor) !important;
        border-color: var(--dialog-btncolor) !important;
        opacity: 1;
      }

      /* 弹窗边框和阴影优化 */
      .el-dialog {
        border: 1px solid var(--dialog-bordercolor);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      }

      /* 表单整体间距优化 */
      .event-form {
        margin: 0;
        padding: 10px 0;
      }

      /* 基准数据名称标签垂直居中 */
      .el-form-item:first-child .el-form-item__label {
        padding-top: 0;
        line-height: 40px;
      }

      /* 输入框内图标的颜色 */
      .el-input__icon {
        color: var(--dialog-textcolor) !important;
      }

      /* 字符计数样式 - 适配单行和多行输入框 */
      .el-input__count,
      .el-input__suffix-inner .el-input__count {
        color: var(--dialog-textcolor) !important;
        background-color: var(--dialog-bgcolor) !important;
      }

      .el-input__count-inner,
      .el-input__suffix-inner .el-input__count-inner {
        color: var(--dialog-textcolor) !important;
      }

      /* 确保单行输入框字符计数正常显示 */
      .el-input__suffix {
        color: var(--dialog-textcolor) !important;
      }

      .my-form-item-group {
        display: flex;
      }

      .my-form-item-group > * {
        flex: 1; /* 平均分配子元素的空间 */
        margin-right: 10px; /* 可选：控制子元素之间的间距 */
      }
    }
  }

  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
    margin-left: 50%;
    background-color: var(--scrollbarbgcolor);
  }

  ::-webkit-scrollbar-thumb {
    margin-left: 50%;
    border-radius: 5px;
    background-color: var(--scrollbarthumbbgcolor);
  }

  .required-asterisk {
    color: #f56c6c;
    margin-left: 2px;
  }

  .required-field {
    border-color: #f56c6c;
  }

}

</style>



// WEBPACK FOOTER //
// src/Page/menu.vue